import { generateCodeFrame } from "vue-template-compiler";

export default {
    global: {
        noLimit: "您没有权限执行此操作，请联系管理员为您添加权限"
    },
    operations: {
        operate: "操作",
        more: "更多",
        turn_on: {
            name: "开机",
            tip: "仅关机状态支持"
        },
        turn_off: {
            name: "关机",
            tip: "仅运行状态支持"
        },
        restart: {
            name: "重启",
            tip: "仅运行状态支持"
        },
        reset_password: {
            name: "重置密码",
            tip: "仅关机状态支持"
        },
        rename: {
            name: "编辑实例名称",
            tip: ""
        },
        reinstall: {
            name: "重装系统",
            tip: "仅关机状态支持"
        },
        bandwidth: {
            name: "调整公网带宽",
            tip: "仅关机/运行状态支持",
            tip_public_ip: "仅有公网IP的实例支持"
        },
        sos: {
            name: "SOS",
            tip: null
        },
        fixsos: {
            name: "修复SOS",
            tip: null
        },
        renew: {
            name: "续费",
            tip: null
        },
        edit_tag: {
            name: "编辑标签",
            tip: "仅关机/运行状态支持"
        },
        turnOnDeleteProtect: {
            name: "开启实例删除保护",
            tip: "已欠费的实例无法开启实例删除保护，请续费后尝试",
            prepaidTip: "仅支持按配置计费实例"
        },
        turnOffDeleteProtect: {
            name: "关闭实例删除保护",
            tip: "已欠费的实例无法开启实例删除保护，请续费后尝试"
        },
        delete: {
            name: "删除",
            tip: "包年包月资源不允许删除",
            tipWithIPv6: "该实例不允许删除，请先关闭IPv6公网带宽",
            tipWithRemoveProtect:
                "已开启实例删除保护，无法执行删除操作。请先关闭实例删除保护后重试",
            tipWithStatus: "仅关机状态支持"
        }
    },
    speechCraft: {
        listEmptyText: "暂无数据或未搜索到相关数据请重新查询",
        listNoText: "暂无数据",
        customList: "请选择要显示在列表的信息，最多选择10个。"
    },
    retailInstance: {
        text: {
            retailInstanceNet: "零售中台网络",
            extensionIntraNetIp: "辅网口不支持自动化设置",
            contactTip: "请线下联系咚咚群",
            batchClose: "批量关机",
            batchOpen: "批量开机",
            batchRestart: "批量重启",
            batchRepassord: "批量重置密码",
            batchRename: "批量编辑实例名称",
            batchDelete: "批量删除",
            search: "查询",
            example: "例如cps.c2.perf1.memory",
            downloadSuccess: "操作成功，正在下载，请稍后",
            empty: "无可用实例规格",
            downloadShow: "导出实例",
            downloadRange: "导出范围",
            downloadAll: "导出全部实例",
            downloadSelect: "导出选中实例",
            downloadSearch: "导出搜索结果",
            chooseInfo: "您已选择{0}台实例：",
            systemDataPartitions: "系统盘分区",
            mountpoints: "挂载点",
            capacity: "容量",
            fileSystem: "文件系统",
            addPartition: "添加分区",
            dataDiskPartition: "数据盘分区",
            allRemainingSpace: "剩余全部空间",
            emptyPartition: "未分区",
            partitions: "分区"
        },
        tooltip: {
            networkQuantityTip1:
                "京东商城零售中台服务器默认使用单网口模式！双网口模式仅针对部分特定业务场景，请您确认您的业务场景是否需要使用双网口！",
            networkQuantityTip2:
                "如果确定使用双网口，仅主网口支持自动化设置，辅网口不支持自动化设置，请线下联系咚咚群",
            chooseTips: "请选择资源",
            turnOff: "仅开机状态实例可以关机",
            turnOn: "仅关机状态实例可以开机",
            restart: "仅开机状态实例可以重启",
            repassword: "仅关机状态实例可以重置密码",
            delete: "仅关机状态且按配置计费的云物理服务器可以删除",
            knowAboutFee: "我已清楚费用问题，我同意自行删除关联的所有资源",
            maxNum: "单次订单最大购买数量为100台,如需扩容，请联系客服或"
        },
        help: {
            sizeFormatError: "只允许数字",
            morePartitionPart2: "个分区",
            only5partitions:
                "最多支持设置{0}个分区，其它分区可在系统安装完成后进入系统进行设置"
        }
    },
    list: {
        searchPlaceholder: {
            id: "请输入ID进行搜索",
            name: "请输入名称进行搜索",
            privateIp: "请输入内网IP地址进行搜索"
        },
        id: "ID/名称",
        region: "可用区",
        networkOperator: "运营商",
        ip: "IP地址",
        netWorkType: "网络类型",
        status: "状态",
        specifications: "规格类型",
        config: "配置",
        chargeInfo: "计费信息",
        operation: "操作",
        customList: "自定义列表",
        moreRegion: "更多地域",
        searchresult1: "查询到符合搜索及筛选条件的资源{0}条,请更换搜索关键字或",
        searchresult2: "查询到符合搜索及筛选条件的资源{0}条,",
        backTolist: "返回列表",
        fuzzySearchTip: "模糊搜索，仅支持单个条件搜索，回车键生成搜索项",
        exactSearchTip: "精确搜索，多个条件值用“,”隔开，回车键生成搜索项",
        IPsearchTip: "可检索实例主IP地址；多个用“,”隔开，回车生成搜索项",
        mutisearchTip: "支持键盘操作：可使用Tab键勾选，Esc键取消，回车键确定",
        fuzzySearch: "模糊搜索",
        exactSearch: "精确搜索",
        keySearch: "将自动匹配ID/内网IPv4/名称进行搜索",
        keySearchTip:
            "如不指定搜索条件，将根据输入特征自动优先匹配主机ID或内网IPv4地址进行搜索，如特征不匹配将统一按名称搜索。"
    },
    text: {
        title: "京东云控制台",
        cancel: "取消",
        confirm: "确定"
    },
    create: {
        text: {
            createKeys: "创建密钥对",
            loginMethods: "登录方式",
            keyPair: "密钥",
            key: "密钥",
            keyTips:
                "若不关联SSH密钥，则无法通过密钥登录OS或者访问SOS带外控制台！",
            publicKey: "密钥登录",
            advanced: "高级设置",
            customData: "自定义数据",
            hasBase64: "以下输入已采用base64编码",
            setPassword: "设置密码",
            customizedPassword: "自定义密码",
            autoPassword: "自动生成密码",
            linkSSHKey: "关联SSH密钥",
            shopping: "购买中",
            makeCps: "创建云物理服务器",
            buyMustKnow: "购买须知",
            yearlyOrMonthly: "包年包月",
            byConfigurations: "按配置",
            byQuantities: "按用量",
            sale: "优惠",
            regionAndAz: "地域与可用区",
            region: "地域",
            az: "可用区",
            spec: "规格",
            cpsType: "机型",
            mirror: "镜像",
            mirrorType: "镜像类型",
            os: "操作系统",
            osVersion: "系统版本",
            application: "应用程序",
            storage: "存储",
            sysDisk: "系统盘",
            sysDiskCapacity: "系统盘总容量",
            sysDiskCapacityUnitTip:
                "（GiB是操作系统使用的二进制容量单位，GB是硬件厂商使用十进制容量单位）",
            defaultPartitionModes: "默认分区",
            customPartitionModes: "自定义分区",
            lastCustomPartition: "最近一次安装系统分区参数",
            dataDisk: "数据盘",
            dataDiskCapacity: "数据盘总容量",
            net: "网络",
            netType: "网络类型",
            privateNet: "内部网络",
            firewall: "防火墙",
            bandwidth: "带宽",
            publicIp: "公网IP",
            bandCal: "带宽计费",
            banCalModel: "带宽计费模式",
            fixedBandwidthPrepaid: "按固定带宽-包年包月",
            fixedBandwidthPostpaid: "按固定带宽-按配置",
            line: "线路",
            bandLimit: "带宽上限",
            aleadyJoinSharedBandwidth: "已加入共享带宽",
            createBandwidth: "新建共享带宽",
            baseInfo: "基本信息",
            name: "实例名称:",
            desc: "描述",
            username: "用户名",
            password: "密码",
            passwordConfirm: "确认密码",
            buyNum: "购买数量",
            buyNo: "购买量",
            buyTimeSpan: "购买时长",
            buySpan: "购买时长",
            count: "数量",
            selectedConfig: "已选配置",
            cost: "费用",
            server: "服务器",
            mainEip: "主网口公网IP",
            extensionEip: "辅网口公网IP",
            original: "原价",
            auto: "自动分配公网IP",
            autoVpc: "购买弹性公网IP",
            autoVpcTip:
                "支持暂不购买弹性公网IP，可在云物理服务器创建完成后另行购买再绑定。",
            autoJoinShareBandwidth:
                "弹性公网IP加入共享带宽后，如果弹性公网IP被移出共享带宽，则会自动给弹性公网IP分配一个按配置计费的独享带宽（带宽：1Mbps）且开始计费，如果弹性公网IP不再使用，建议尽快删除 。",
            root: "root",
            month: "个月",
            yearUnit: "年",
            year: "1年",
            twoYears: "2年",
            threeYears: "3年",
            memory: "内存",
            netCard: "网卡",
            basic: "基础网络",
            info: "提示",
            caution: "注意",
            readAgree: "已阅读并同意",
            confirm: "确定",
            cancel: "取消",
            save: "省",
            standardImage: "标准镜像",
            standardAppImage: "标准镜像+应用",
            buyNow: "立即购买",
            payNow: "立即支付",
            range: "范围",
            calculating: "计算中...",
            paying: "支付中",
            specType: "规格类型",
            cpu: "CPU",
            gpu: "GPU",
            series: "系列",
            soldOut: "售罄",
            hostName: "主机名",
            computeType: "计算",
            storageType: "存储",
            gpuType: "GPU",
            currentDeviceType: "当前选择规格:",
            autoRenew: "自动续费",
            autoRenewTip: "账户金额充足时，将在到期前按购买时长自动续费。",
            uploadText: "以文本形式",
            uploadFile: "以文件形式",
            chooseFile: "选择文件",
            yearPackage: "当前配置包年包月仅售￥{0}/月",
            feePerHour: "¥{0}/小时",
            monthPay: "(合计￥{0}/月)",
            configureMonthPay: "(按配置月费用合计￥{0}/月)",
            openIpv6WithoutVpcTip: "所选的私有网络未开通IPv6，请去",
            openIpv6WithoutSubnetTip: "所选的子网未开通IPv6，请去",
            openIpv6WithoutVpcTip1: "所选的私有网络未开通IPv6",
            openIpv6WithoutSubnetTip1: "所选的子网未开通IPv6",
            allotPrivateIpv6: "分配内网IPv6",
            relativeNetworkInterface: "关联网口",
            internetAccessType: "网络接口数量",
            singleInternetAccess: "单网口",
            doubleInternetAccess: "双网口",
            targetInternetAccessName: "目标网络接口名称",
            singleInternetAccessChiefName: "主网口(bond0)",
            chiefInternetAccessName: "主网口(eth0)",
            subInternetAccessName: "辅网口(eth1)",
            networkQuantityAndName: "网络数量与名称",
            networkQuantity: "@:eip.text.internetAccessType",
            networkName: "网络接口名称",
            singleInternetAccess: "@:eip.text.singleInternetAccess",
            doubleInternetAccess: "@:eip.text.doubleInternetAccess",
            singleInternetAccessChiefName:
                "@:eip.text.singleInternetAccessChiefName",
            chiefInternetAccessName: "@:eip.text.chiefInternetAccessName",
            subInternetAccessName: "@:eip.text.subInternetAccessName",
            networkQuantityAndName: "网络数量与名称",
            networkQuantity: "@:eip.text.internetAccessType",
            networkName: "网络接口名称",
            singleInternetAccess: "@:eip.text.singleInternetAccess",
            doubleInternetAccess: "@:eip.text.doubleInternetAccess",
            singleInternetAccessChiefName:
                "@:eip.text.singleInternetAccessChiefName",
            chiefInternetAccessName: "@:eip.text.chiefInternetAccessName",
            subInternetAccessName: "@:eip.text.subInternetAccessName",
            chiefAndSubInternetAccessName:
                "@:eip.text.chiefInternetAccessName，@:eip.text.subInternetAccessName",
            networkAndBandWidth: "网口与带宽设置",
            securityNetwork: "安全设置",

        },
        tooltip: {
            keyPairTips:
                "当前仅支持云物理服务器创建/重装时关联密钥,只有开启并正确设置SSH密钥才可访问SOS带外控制台",
            keyPairTip:
                "当前仅支持云物理服务器创建/重装系统时绑定密钥。若仅选择密钥登录，则需要用户手动修改密码才可访问 SOS 带外控制台。",
            publicKeyTip:
                "密钥对由公有密钥和私有密钥文件构成。如果您选择了密钥登录方式， 我们将默认禁用用户名密码的登录方式。",
            loginTip:
                "自动生成密码：若选择自动生成密码，将以短信及邮件方式发送系统生成密码，请注意查收。 密钥登录： 当前仅支持云物理服务器创建/重装时绑定密钥。若仅选择密钥登录，则需要用户手动修改密码才可访问SOS带外控制台。",
            loginTips:
                " 密钥登录： 当前仅支持云物理服务器创建重装时绑定密钥。自动生成密码：若选择自动生成密码，将以短信及邮件方式发送系统生成密码，请注意查收。",
            customData:
                "用于启动时配置实例，仅在实例系统首次启动时执行。如果您一次启动多个实例，用户数据可供所有实例使用。",
            setPasswordTip:
                "若选择自动生成密码，将以短信及邮件方式发送系统生成密码，请注意查收。",
            region: "不同地域资源内网不互通，创建后不可更改。",
            az: "不同可用区资源内网不互通，创建后不可更改。",
            sysDisk:
                "系统盘若为一块硬盘，则自动配置为NO RAID。系统盘为两块硬盘，则自动配置为RAID1。",
            systemPartition:
                "当系统盘RAID模式为NO RAID时，操作系统仅支持安装在其中一块硬盘中，所以支持自定义的分区容量显示为单块硬盘容量。",
            netTypeWarning:
                "一个可用区只可以创建一个内网，不同可用区创建的内网默认不互通。",
            netType:
                "一个可用区只可以创建一个内网，不同可用区创建的内网默认不互通。如需不同内网之间网络互通，请在工单系统提交申请，待网络专家评估后回复。",
            internalNet:
                "用户在同一可用区只可以创建一个内网。创建主机后，内网网段不可修改，建议创建前做好网络规划。",
            internalNetDisabled:
                "同一可用区下，用户仅在创建第一台云物理服务器时可以配置内网网段，内网网段创建后不可修改，后续购买的云物理服务器默认使用该内网网段。如果用户在该可用区下的所有云物理服务器均已被回收，再次购买第一台云物理服务器时可重新配置内网网段。建议用户创建云物理服务器前做好网络规划。",
            auto:
                "公网IP与云物理服务器绑定，不可解绑。有效期与主机相同。带宽可升配，不可降配。",
            cal:
                "购买固定带宽类型公网IP根据用户所选公网出带宽上限计费，单位为Mbps，适用于网络情况较稳定的业务场景。 购买选择加入共享带宽，不单独收取带宽费用。按共享带宽统一计费，大幅节省成本。",
            detail: "详情介绍",
            line: "{0}网络可提供更高的访问速度。",
            notEnough: "资源不足，请尝试减少主机购买数量,",
            soldOut: "已售罄！您可以选择其他资源，",
            cusService: "也可以联系客服400-615-1212（7*24小时），或",
            ticket: "提交工单。",
            oneYearDiscount: "1年云物理服务器享8.3折优惠",
            twoYearDiscount: "2年云物理服务器享8.3折优惠",
            threeYearDiscount: "3年云物理服务器享8.3折优惠",
            discount: "{0}年云物理服务器享受{1}折优惠",
            autoRenew:
                "资源创建后，自动续费属性和时长均修改。按月购买，则自动续费周期为1个月；按年购买，则自动续费周期为1年，按年自动续费享受自动续费折扣。",
            hasNoFile: "未选择任何文件",
            networkQuantityTip: "单网口指逻辑网络接口；双网口指物理网络接口；",
            mainNetwork:
                "若实例的网卡速率为10GE，选择单网口(bond0)模式后会变为20GE；若实例的网卡速率是25GE，选择单网口(bond0)模式后会变为50GE",
            subNetwork:
                "eth0是主网口在操作系统中的名称，eth1是辅网口在操作系统中的名称",
            joinShareBandwidth:
                "弹性公网IP加入到包年包月的共享带宽，如果共享带宽实例到期不续费导致释放，则会自动给弹性公网IP分配一个按配置计费的独享带宽且开始计费，如果弹性公网IP不在使用，建议尽快删除。"
        },
        help: {
            publicKeySetting: "使用密钥登录请参考",
            spec: "根据具体业务情况选择不同云物理服务器规格类型，可参考",
            detail: "规格详情。",
            systemVersionSpec: "为了获得更好的游戏体验，请到游戏服务器页面",
            systemVersionDetail: "创建资源。",
            will: "将在",
            distributeIp: "区间内分配内网IP，最多可创建",
            numCps: "台云物理服务器。",
            firewall: "内网全部开放，公网开放22端口（远程SSH登录）。",
            reference: "防火墙设置请参考",
            guide: "操作指南。",
            ddos: "京东云自动为您免费提供最高2Gbps的恶意流量攻击防护。",
            ddosVpc:
                "京东云自动为您免费提供最高2Gbps的恶意流量攻击防护，开启DDoS基础防护请参考",
            ddosVpcGuid: "操作指南。",
            name:
                "1-32字符，只允许中文、数字、大小写字母、英文下划线“_”及中划线“-”。",
            desc: "长度不超过256字符。",
            password:
                "8-30个字符，且同时包含三项（大写字母，小写字母，数字或特殊符号()`~!@#$%&*_-+=|{}[]:\";'<>,.?/）。",
            publicIpNoConfirm: "确认不购买公网IP？",
            noPublicIp:
                "如果不购买公网IP，您将不能从公网访问云物理服务器。公网IP不支持后期添加。",
            maxNum: "单次订单最大购买数量为5台,如需扩容，请联系客服或",
            autoShowTip: "{0}区间内自动分配",
            autoAllocate: "{0}区间内自动分配",
            byBandwidth: "{0} 按带宽 {1} Mbps",
            bySharedBandwidth: "{0} 共享带宽 {1} Mbps",
            noCertification: "您尚未实名认证，购买云物理服务器须实名认证,",
            goCertificate: "去认证",
            soldOut: "已售罄！",
            restock: "补货中!",
            contact: "咨询请联系客服400-615-1212（7*24小时），或",
            exceedQuota: "超过购买配额!",
            autoPublicIpv6: "系统自动分配IPv6地址",
            autoIpv6: "自动分配IPv6地址",
            enableIpv6: "启用IPv6",
            publicOpen: "内网全部开放",
            mainName:
                '2-60 个字符，允许使用大小写字母、数字、连字符 "-"，不能连续使用 "-"，"-"不能用于开头或结尾。',
            instanceName:
                "实例名称是指云物理服务器的别名，用户可以自定义设置，设置完成后可以通过云物理服务器列表中使用别名来筛选。一次购买多台云物理服务器的情况下，默认在设置名称后面加上数字，以递增的形式来标志多台云物理服务器。同时支持在名称的任意位置插入序号替换符，形如{{index}}，创建时替换符将被替换为递增序列数字，例如：输入IT{{index}}cloud，数量为3，创建后名称依次为IT1cloud，IT2cloud，IT3cloud。",
            hostName:
                "主机名是指云物理服务器操作系统内部的计算机名，用户可以自定义设置，云物理服务器成功生产后可以通过登录云物理服务器内部查看。一次购买多台云物理服务器的情况下，默认在设置名称后面加上数字，以递增的形式来标志多台云物理服务器。同时支持在名称的任意位置插入序号替换符，形如{{index}}，创建时替换符将被替换为递增序列数字，例如：输入IT{{index}}cloud，数量为3，创建后名称依次为IT1cloud，IT2cloud，IT3cloud。",
            onlyOne: "若选择手动分配内网IP，暂不支持批量创建云物理服务器。",
            EipExceedQuota: "EIP超过购买配额!",
            CPSOverStock: "云物理服务器超过购买配额!",
            instanceNameRule1:
                "2-128个字符，以大小写字母或中文开头，可包含数字、“.”、“_”、“:”、“-”或“{}”。",
            instanceNameRule:
                "2-128个字符，以大小写字母或中文开头，可包含数字、“.”、“_”、“:”或“-”。",
            mainServerNameRule:
                "长度为2-64个字符，允许使用点号(.)分隔字符成多段，每段允许使用大小写字母、" +
                "数字或连字符(-)，但不能连续使用点号(.)或连字符(-)。不能以点号(.)或连字符(-)开头或结尾.",
            aleadyJoinSharedBandwidth: "（带宽：{0}Mbps）"
        },
        placeholder: {
            codeExample: "示意：\n #!/bin/bash \n echo 'hello world'\n",
            windowsCodeExample: "示意：\n rem cmd \n echo 'hello world'\n",
            customData:
                "Linux系统支持bash和python，编码前须分别以#!/bin/bash和#!/usr/bin/env python作为内容首行；请在 Linux 环境下进行编码，避免格式不兼容，且原始数据不大于16KB",
            windowsTips:
                "Windows系统支持bat和powershell，编码前须分别以“rem cmd”开头且作为内容首行和<powershell></powershell>作为内容首、尾行。请在Linux环境下进行编码，避免格式不兼容，且原始数据不大于 16KB。",
            version: "请选择系统版本",
            application: "至少选择一项应用程序",
            fixedBandwidth: "按固定带宽",
            enhanced95: "按增强型95",
            nameNull: "名称不能为空",
            passNull: "密码不能为空",
            confirmPassNull: "确认密码不能为空",
            passNotSame: "确认密码与密码不相同",
            passNotMeetRequire: "密码不符合要求",
            passwordNotSame: "密码不一致",
            mainName: "可选填，操作系统内部的计算机名",
            ipAddressNotPass: "请输入合法IP地址",
            ipAddressRepeat: "IPv4地址重叠或超出子网IPv4 CIDR范围",
            ipv6AddressNotPass: "请输入合法IPv6地址",
            subCidrNameNull: "次要CIDR不能为空",
            certificateNull: "证书不能为空",
            default: " "
        },
        error: {
            uploadFileFormatError: "上传文件格式错误，请重新上传",
            uploadFileSizeError: "上传文件大小不能大于16KB",
            uploadFileBase64:
                "当前文件内容已进行base64编码，请勾选“以下输入已采用base64编码”",
            uploadFileNotBase64:
                "当前文件内容未进行base64编码，请取消勾选”以下输入已采用base64编码“"
        }
    },
    listPage: {
        speechCraft: {
            title: "云物理服务器",
            helpDocument: "云物理服务器帮助文档",
            monitorTo: "可前往云监控",
            alarmRules: "设置报警规则",
            commitWorkSheet: "点击提交工单",
            adjustPublicBandWidth: "调整公网带宽",
            tipWaring: "调整带宽只支持升配，不支持降配。操作即时生效。",
            reInstallTipWaring:
                "注意：</br>" +
                "1、重装系统针对系统盘做初始化、更换操作系统操作。</br>" +
                "2、该操作会清空云物理服务器系统盘内数据，请您做好备份，若由于未备份造成的数据丢失，京东云概不负责。</br>" +
                "3、如果选择格式化数据盘数据，数据盘数据也将同时被清空。重装系统需要重新加载已挂载的数据盘。</br>",
            chooseMoreThanOne: "至少选择一项应用程序",
            passwordVerify: "密码不能为空",
            repasswordVerify: "确认密码不能为空",
            passwordType:
                "8-30个字符，且同时包含三项(大写字母，小写字母，数字或特殊符号()`~!@#$%&*_-+=|{}[]:\";'<>,.?/）。",
            sureSame: "确认密码与密码不相同",
            simFormat: "同时格式化所有数据盘",
            reInstallTip:
                "注意：重装系统针对系统盘做初始化、更换操作系统操作。该操作会清空云物理服务器系统盘内数据，请您做好备份，若由于未备份造成的数据丢失，京东云概不负责。如果选择不保留数据盘数据，数据盘数据也将同时被清空。重装系统需要重新加载已挂载的数据盘。",
            ReSureInstall: "确认对云物理服务器：{0}进行重装系统操作？",
            applicationTooltips: {
                Nginx:
                    "Nginx是一款轻量级的Web 服务器/反向代理服务器及电子邮件（IMAP/POP3）代理服务器，并在一个BSD-like 协议下发行。其特点是占有内存少，并发能力强。",
                MySQL:
                    "MySQL 是最流行的关系型数据库管理系统之一，在 WEB 应用方面，MySQL是最好的 RDBMS (Relational Database Management System，关系数据库管理系统) 应用软件。",
                RabbitMQ:
                    "RabbitMQ是一个在AMQP基础上完成的，可复用的企业消息系统。他遵循Mozilla Public License开源协议。"
            },
            confirmNet: "调整带宽只支持升配，不支持降配",
            hostNameRule:
                '2-60字符，允许使用大小写字母，数字，连字符"-"，不能连续使用"-"，"-"不能用于开头和结尾。',
            dataFormattedRedWarning: "数据盘数据将同时会被清空",
            reinstallConfirmCheckWarning:
                "我确认选择【{0}】模式同时格式化所有数据盘，数据盘数据将同时被清空。",
            deleteInstanceTip:
                "注意:</br>" +
                "1、云物理服务器删除后所有数据将被清除且不可恢复，请提前备份数据;</br>" +
                "2、云物理服务器删除时，负载均衡的虚拟服务器组中的资源也会被删除;但是所绑定的弹 性公网 IP 将继续保留，如不需保留，请前往对应页面删除，以免产生额外费用。",
            sureCharge: "我已清楚费用问题，我同意自行删除关联的所有资源",
            deleteInstanceChecnkWarning: "确认删除云物理服务器 ：{0}?"
        },
        placeholder: {
            choose: "请选择",
            chooseSystemOperate: "请选择系统版本",
            currentPlaceholder: "请输入名称进行搜索"
        },
        text: {
            create: "创建",
            public: "(公)",
            private: "(内)",
            error: "错误",
            run: "运行",
            shutdown: "关机",
            hasExpired: "已过期",
            created: "创建",
            expired: "到期",
            freed: "释放",
            cost: "费用",
            price: "原价",
            saving: "省",
            cancel: "取消",
            currencySymbol: "￥",
            cancelButton: "取 消", // 感觉有其他处理方法
            sureButton: "确 定",
            reInstallSystem: "重装系统",
            hostInformation: "主机信息",
            hostNowInformation: "主机当前信息",
            maxBandWidth: "带宽上限",
            exampleID: "实例ID",
            exampleName: "实例名称",
            powerIn: "开机中",
            shuttingDown: "关机中",
            rebooting: "重启中",
            creating: "创建中",
            destroying: "销毁中",
            reconfiging: "调整配置中",
            reinstalling: "重装系统中",
            unknown: "未知",
            intermediate: "中间态",
            baseNet: "基础网络",
            prepaid_by_duration: "包年包月",
            postpaid_by_duration: "按配置",
            currentMirror: "当前镜像",
            standardImage: "标准镜像",
            imageAndApp: "标准镜像+应用",
            exportList: "导出资源列表",
            customList: "自定义列表",
            publicIpv4: "(公网IPv4)",
            publicIpv6: "(公网IPv6)",
            privateIpv4: "(内网IPv4)",
            pubIpv4: "公网IPv4：",
            pubIpv6: "公网IPv6：",
            priIpv4: "内网IPv4：",
            resettingPassword: "重置密码中",
            tags: "标签",
            expirationDate: "调整后到期时间",
            delete: "删除",
            targetIpAddressTip:
                "IP地址为实例主网口的主IP地址及绑定的弹性公网IP地址",
            configTip: "带宽上限为实例主网口的主IP所绑定的弹性公网IP带宽值",
            deploymentRefundFee: "调配退还费用",
            deploymentSupplementFee: "调配补款费用",
        },
        tableLabel: {
            idOrName: "ID/实例名称",
            availableArea: "可用区",
            ipAddress: "IP地址",
            netType: "网络类型",
            status: "状态",
            specificationType: "规格类型",
            config: "配置",
            billingInformation: "计费信息",
            name: "名称",
            publicIp: "公网IP",
            publicIpAddr: "公网IP地址",
            expireTime: "到期时间",
            currentBandWidth: "当前带宽",
            billMethods: "计费方式",
            systemDisk: "系统盘",
            mirroringType: "镜像类型",
            operateSystem: "操作系统",
            systemVersion: "系统版本",
            applicationSystem: "应用程序",
            mirroring: "镜像",
            administrator: "管理员",
            password: "密码",
            repassword: "确认密码",
            dataDisk: "数据盘",
            operation: "操作",
            hostName: "主机名",
            dataDiskType: "数据盘RAID类型",
            dataDiskConfig: "数据盘RAID配置",
            targetInternetIp: "目标内网IP",
            chooseEip: "选择EIP",
            targetIpAddress: "主IP地址"
        },
        errorMessage: {
            passwordRule: ["密码不符合要求", "密码不一致"],
            params: "参数超出范围"
        }
    },
    detail: {
        text: {
            diskReadWrite: "磁盘读/写流量 ",
            diskCountReadWrite: "磁盘读/写IOPS ",
            networkTraffic: "网卡进/出流量 ",
            networkPacket: "网络进/出包数量 ",
            rangeForSearch: "选择查询的日期范围",
            diskUsed: "磁盘使用量",
            diskUtil: "磁盘使用率",

            cpuUsed: "CPU使用率",
            memoryUsed: "内存使用率",
            memoryUtil: "内存使用量",
            tcPConnectionCount: "TCP总连接数",
            activeTCPConnections: "TCP正常连接数",
            totalProcessCount: "总进程数",
            oneMinuteLoadAverage: "平均负载1min",
            fiveMinuteLoadAverage: "平均负载5min",
            fifteenMinuteLoadAverage: "平均负载15min",
            gpuMemoryTotal: "GPU 总显存",
            gpuUtilization: "GPU 使用率",
            gpuMemoryUsed: "GPU 显存使用量",
            gpuMemoryUtilization: "GPU 显存使用率",

            rangeH: "{0}小时",
            rangeD: "{0}天",
            timeRangeH: "小时",
            timeRangeD: "天",
            rangeSeparator: " 至 ",
            renewals: "续费",
            operate: "操作",
            sourceInfo: "资源信息",
            baseInfo: "基本信息",
            id: "ID",
            name: "实例名称",
            newName: "新实例名称",
            modifyName: "修改名称",
            cancel: "取消",
            sure: "确定",
            describe: "描述",
            modifyDescribe: "修改描述",
            billingType: "计费类型",
            createTime: "创建时间",
            expireTime: "到期时间",
            region: "地域",
            availableArea: "可用区",
            configurationInfo: "配置信息",
            mirroring: "镜像",
            spec: "规格",
            systemDisk: "系统盘",
            dataDisk: "数据盘",
            netInfo: "网络信息",
            podName: "Net-POD",
            iloIp: "带外管理 IP",
            cabinet: "机柜编码",
            intranetIp: "内网IP",
            onetSegment: "所属网段CIDR",
            firewall: "防火墙",
            publicNetIP: "公网IP",
            publicNetBandWidth: "公网带宽",
            operationsGuide: "操作指南。",
            hardWareMonitor: "硬件监控",
            performanceMonitor: "性能监控",
            monitor: "监控",
            device: "设备",
            statue: "状态",
            status: "状态",
            normal: "正常",
            abnormal: "异常",
            maxBandWidth: "带宽上限",
            currentBandWidth: "当前带宽",
            billingMethods: "计费方式",
            cost: "费用",
            price: "原价",
            saving: "省",
            currencySymbol: "￥",
            reInstallSystem: "重装系统",
            hostInformation: "主机信息",
            mirroringType: "镜像类型",
            operateSystem: "操作系统",
            systemVersion: "系统版本",
            application: "应用程序",
            administrator: "管理员",
            password: "密码",
            repassword: "确认密码",
            operation: "操作",
            copySuccess: "复制成功",
            powerIn: "开机中",
            shuttingDown: "关机中",
            rebooting: "重启中",
            creating: "创建中",
            destroying: "销毁中",
            reconfiging: "调整配置中",
            reinstalling: "重装系统中",
            error: "错误",
            run: "运行",
            shutdown: "关机",
            prepaid_by_duration: "包年包月",
            standardImage: "标准镜像",
            imageAndApp: "标准镜像+应用",
            "cn-east-1": "华东-宿迁",
            "cn-north-1": "华北-北京",
            "cn-east-1a": "可用区A",
            "cn-north-1b": "可用区B",
            "cn-north-1a": "可用区A",
            "cn-north-1c": "可用区C",
            intermediate: "中间态",
            memory: "内存",
            netCard: "网卡",
            hardDisk: "硬盘",
            restart: "重启",
            graphics: "显卡",
            power: "电源",
            other: "其它",
            hardwareStatusList: "硬件设备状态列表",
            hardwareStatus: "硬件设备状态",
            warningLogList: "报警日志列表",
            warningLogNumber: "报警日志编号",
            warningTime: "报警时间",
            warningLogContent: "报警日志内容",
            netAccessDetail: "网口详情",
            netAccessType: "网络接口类型",
            publicNetIp: "公网IP(主IP)",
            interNetIp: "内网IP(主IP)",
            ipType: "IP类型",
            bondedAliasIpRange: "已绑定的别名IP范围(IPv4)",
            bondedIPv6AliasIpRange: "已绑定的别名IP范围(IPv6)",
            primaryIp: "主IP",
            netAccessDetail: "网口详情",
            netAccessType: "网络接口类型",
            publicNetIpv4: "公网IPv4(主IP)",
            interNetIpv4: "内网IPv4(主IP)",
            interNetIpv6: "内网IPv6(主IP)",
            eipv6: "公网IPv6",
            typeIpv6: "IPv6类型",
            addressIpv6: "IPv6地址",
            monitorInstance: "实例",
            monitorDisk: "磁盘",
            monitorDiskPiece: "磁盘分区",
            net: "网口",
            logid: "序号",
            alertType: "故障类型",
            alertDesc: "故障描述",
            eventTime: "故障报警时间",
            updateTime: "更新时间",
            count: "告警次数",
            alertStatus: "状态",
            unhandled: "未处理",
            recovered: "已恢复",
            ignored: "已忽略"
        },
        speechCraft: {
            title: "云物理服务器",
            helpDocument: "云物理服务器帮助文档",
            nameNoNull: "名称不能为空",
            editNameRule:
                "1-32字符，只允许中文、数字、大小写字母、英文下划线“_”及中划线“-”。",
            descriptionLongRule: "长度不超过256字符",
            fireWallDefault: "默认Linux开放22端口",
            clickToCommit: "点击提交工单",
            adjustPubNetBand: "调整公网带宽",
            publicNetTip: "调整带宽只支持升配，不支持降配。操作即时生效。",
            reInstallTip:
                "注意：重装系统针对系统盘做初始化、更换操作系统操作。" +
                "该操作会清空云物理服务器系统盘内数据，请您做好备份，若由于未备份造成的数据丢失，京东云概不负责。" +
                "如果选择不保留数据盘数据，数据盘数据也将同时被清空。重装系统需要重新加载已挂载的数据盘。",
            moreThanOneTip: "至少选择一项应用程序",
            passwordVerify: "密码不能为空",
            password:
                "8-30个字符，且同时包含三项（大写字母，小写字母，数字或特殊符号()`~!@#$%&*_-+=|{}[]:\";'<>,.?/）。",
            repasswordVerify: "确认密码不能为空",
            sureSame: "确认密码与密码不相同",
            simFormat: "同时格式化所有数据盘",
            sureReInstall: "确认对云物理服务器：{sysName} 进行重装系统操作？",
            applicationTooltips: {
                Nginx:
                    "Nginx是一款轻量级的Web 服务器/反向代理服务器及电子邮件（IMAP/POP3）代理服务器，并在一个BSD-like 协议下发行。其特点是占有内存少，并发能力强。",
                MySQL:
                    "MySQL 是最流行的关系型数据库管理系统之一，在 WEB 应用方面，MySQL是最好的 RDBMS (Relational Database Management System，关系数据库管理系统) 应用软件。",
                RabbitMQ:
                    "RabbitMQ是一个在AMQP基础上完成的，可复用的企业消息系统。他遵循Mozilla Public License开源协议。"
            },
            reInstallSuccess: "重装系统成功",
            confirmNet: "调整带宽只支持升配，不支持降配",
            dickPieceTip: "Linux系统按分区挂载点上报，Windows系统按盘符上报",
            dickTip: "Linux系统按设备名上报， Windows系统按盘符上报"
        },
        placeholder: {
            editName: "编辑名称",
            selectSystemVersion: "请选择系统版本"
        },
        errorMessage: {
            passwordRule: ["密码不符合要求", "密码不一致"]
        }
    },
    popHelper: {
        speechCraft: {
            repasswordTip: "重置密码提示",
            repasswordWaring: [
                "十分抱歉！重置密码暂时不支持线上操作 ",
                "您可以提交工单或联系客服 ",
                "400-615-1212 （7*24小时）"
            ],
            sureOpen: "确认开启云物理服务器：{0}?",
            sureClose: "确认关闭云物理服务器：{0}?",
            sureRestart: "确认重启云物理服务器：{0}?",
            stockNotEnough: "库存不足提示",
            stockNotEnoughWaring: [
                "十分抱歉！您当前选择的机型库存不足 ",
                "您可以选择其它机型或提交工单，也可以",
                "联系客服 "
            ],
            userQuota: [
                "超过用户累计购买数量",
                "超过用户累计购买数量，请调整购买数量"
            ],
            personalUser: [
                "个人用户暂不支持",
                "目前暂不对个人认证用户开放低价折扣优惠活动，请静待后续活动，或在用户管理页面升级为企业用户。"
            ],
            onlyOne: ["购买数量超限", "活动期间仅限购买1台云物理服务器"],
            unpaidOrder: [
                "存在未支付订单",
                "您有未支付订单，请在订单管理页面支付未支付订单。"
            ]
        },
        text: {
            sure: "确定",
            cancel: "取消",
            openSuccess: "开机成功",
            closeSuccess: "关机成功",
            restartSuccess: "重启成功",
            submitSheet: "提交工单"
        },
        title: {
            open: "开机提示",
            close: "关机提示",
            restart: "重启提示"
        }
    },
    orderConfirm: {
        text: {
            orderConfirm: "订单确认",
            payConfirm: "支付确认",
            payFinish: "支付完成",
            orderInfo: "订单信息",
            productType: "产品类型",
            configInfo: "配置详情",
            chargeType: "计费类型",
            timeSpan: "购买时长",
            number: "数量",
            fee: "费用",
            currentConfig: "当前配置",
            afterConfig: "调整后配置"
        },
        help: {
            forYourSafetyUse:
                "为保证您的正常使用，包年包月资源在到期前不支持删除。",
            readAndAgree: "我已阅读并同意",
            cpsTerms: "《云物理服务器服务条款》",
            shouldPay: "应付金额：",
            original: "原价：￥",
            save: "省：￥"
        }
    },
    // 子网
    subnet: {
        text: {
            privateNetwork: "私有网络",
            createPrivateNetwork: "创建私有网络",
            cidr: "主要IPv4 CIDR",
            subCidr: "次要IPv4 CIDR",
            cidrAddress: "CIDR地址",
            cidrType: "CIDR类型",
            ipv6Cidr: "IPv6 CIDR",
            primaryIpv6Cidr: "主要IPv6 CIDR",
            vpcIpv6Cidr: "VPC IPv6 CIDR",
            subnetIpv6Cidr: "子网主要IPv6 CIDR",
            openIpv6: "开通IPv6",
            create: "创建子网",
            name: "名称",
            netBelongTo: "所属网络",
            availableIpToAllIp: "可用IPv4/总IPv4(主)",
            availableIpToAllIpSub: "可用IP/总IP（次）",
            availableIpv6ToAllIp: "已用IPv6/总IPv6(主)",
            delete: "删除",
            subnetCidr: "子网CIDR",
            privateIp: "内网IPv4",
            publicIp: "公网IPv4",
            ipAliasRange: "别名IP范围",
            addIpAliasRange: "添加别名IP范围",
            subnetRange: "子网范围",
            subnet: "子网",
            deleteSubnet: "删除子网",
            save: "保存",
            edit: "编辑",
            forExample: "示例：10.0.1.1/24或/32",
            routeMap: "路由表",
            defaultRouteMap: "默认路由表",
            operationSuccess: "操作成功",
            addSubCidr: "添加次要IPv4 CIDR",
            subCidrName: "次要CIDR名称",
            mainCidr: "主要IPv4 CIDR",
            mainIpv6Cidr: "主要IPv6 CIDR",
            addSuccess: "添加成功",
            noAvailableIpAddress: "无可用IP地址",
            noAvailableIpv6Address: "无可用IPv6地址",
            allocacateSource: "分配来源",
            deleteAliasIp: "删除别名IP范围",
            ipAlias: "别名IPv4",
            alreadyAllocateIpAliasRange: "已分配别名IP范围",
            deleteSubCidr: "删除次要CIDR",
            ipv6Forexample: "请输入完整IPv6 CIDR"
        },
        help: {
            doc: "子网帮助文档",
            confirmToDelete: "确认删除子网: {0}?",
            vpcHasSubnetNo: "当前私有网络已有子网",
            count: "个",
            cidr: "所输入子网掩码会影响到该子网所创资源数",
            NoCidr: "暂无可用子网CIDR",
            cidrNotStandard: "请输入合法且标准的别名IP范围",
            ipv6CidrStandard: "所设别名IP范围不符合 IPv6地址规则，请重新设置",
            cidrOutOfRange: "别名IP范围有重叠或超出主要CIDR/次要CIDR",
            cidrIpv6OutOfRange:
                "所设别名IP范围不在子网主要IPv6 CIDR内 ，请重新设置",
            cidrOverLap: "别名IP范围有重叠",
            cidrIpv6OverLap:
                "所设别名IP范围与子网内已分配IP地址范围有重叠，请重新设置",
            cidrIsRetain: "别名IP范围最后1位支持输入范围2~254",
            moreAliasIpAvailablePart0: "还可添加 ",
            moreAliasIpAvailablePart1:
                "还可添加别名IP范围数量: 别名IP范围(IPv4)",
            moreAliasIpAvailablePart2: "个",
            moreAliasIpAvailablePart3: ", 别名IP范围(IPv6)",
            appointIpAliasRange: "请在{0}内指定别名IP范围",
            aliasIpCannotBeNull: "别名IP范围不能为空",
            only10IpAliasForOneInstance: "同一网口下仅支持添加50个别名IP范围",
            changeSubnetForAliasIpWarning:
                "若已经输入别名IP范围，再次切换选择私有网络或者子网会清空全部别名IP范围",
            confirmToDeleteIpAliasRange:
                "确定删除别名IP范围{0}吗？删除后将与资源自动解绑。",
            confirmToDeleteIpv6AliasRange:
                "确定删除别名IP范围{0}吗？删除后将与资源自动解绑。删除后将与资源自动解耦，别名IP范围内的IPv6地址将不可用。",
            moreSubCidrPart2: "个次要IPv4 CIDR",
            onlyOneSubCidr: "同一子网下仅支持创建一个次要IPv4 CIDR",
            subCidrTipPart1: "1-32字符，只允许中文、数字、大小写字母、英文",
            subCidrTipPart2: "下划线“_”及中划线“-”。",
            addAliasSuccess: "添加成功的别名IP范围如下（{0}个）",
            addAliasFail: "添加失败的别名IP范围如下（{0}个）",
            enterSubCidr: "请输入次要Ipv4 CIDR",
            enterSubCidrName: "请输入次要CIDR名称",
            onlyForCreateLocateIpAlias: "仅用于创建别名IP范围使用",
            confirmToDeleteSubCidr:
                "确定删除{0}({1})吗？删除后将与资源自动解绑。",
            subnetNetCannotBeNull: "请选择子网范围",
            quotaExceed: "配额不足",
            usedDeleteNotAllowed: "资源已被使用，不允许删除"
        },
        tooltip: {
            vpcIpv6Cidr: "系统为VPC分配的IPv6网段",
            ipv6CidrError: "输入范围0-f"
        },
        operations: {
            delete: {
                name: "删除",
                tip: "无法删除子网，请先删除该子网内的资源"
            },
            enableipv6: {
                name: "开通IPv6",
                tip: ""
            }
        }
    },
    // 弹性IP
    eip: {
        text: {
            eip: "弹性公网IP",
            eipv4: "弹性公网IPv4",
            apply: "申请",
            ipAddress: "IP地址",
            ipId: "IP ID",
            allAz: "全可用区",
            unBond: "未绑定",
            publicIdOrAddress: "公网IP ID/地址",
            line: "线路",
            bandwidth: "带宽",
            bandwidthLimit: "带宽上限",
            bindSource: "绑定资源",
            modifyBandwidth: "修改带宽",
            joinShareBandwidth: "加入共享带宽",
            alreadyJoinedSharedBandwidth: "已加入共享带宽",
            joinShareBandwidthTip:
                "弹性公网IP加入共享带宽后：</br>" +
                "1、原本的带宽值失效,变为和共享带宽的相同，加入后带宽：{0} Mbps;</br>" +
                "2、原来的计费模式失效，变为单纯的IP，不额外计带宽费用;</br>" +
                "3、预付费包年包月的弹性公网IP暂时不支持添加到共享带宽;</br>",
            removeShareBandwidth: "移出共享带宽",
            removeShareBandwidthTip:
                "弹性公网IP移出共享带宽后：</br>" +
                "1、恢复加入共享带宽之前的带宽上限：带宽{0}Mbps;</br>" +
                "2、恢复加入共享带宽前的计费模式：按配置计费(按固定带宽)</br>",
            bandwidthPackage: "共享带宽",
            independentBandwidth: "按固定带宽计费",
            bonded: "已绑定",
            applyPublicIp: "申请公网IP",
            cpsEip: "云物理服务器EIP",
            cpsEipServiceItem: "《物理云公网IP服务条款》",
            bindSourceInfo: "绑定资源信息",
            applyTime: "申请时间",
            sourceType: "资源类型",
            privateAddress: "内网地址",
            unbindPublicIp: "解绑公网IP",
            instanceType: "实例类型",
            unbindSource: "解绑资源",
            status: "状态",
            chooseSource: "选择资源",
            sourceName: "资源名称",
            cps: "云物理服务器",
            id: "ID",
            originalPrice: "原价：￥ {0}",
            discountedPrice: "省：￥ {0}",
            bandwidthCalMode: "带宽计费模式",
            selectedIP: "已选IP",
            selectIP: "可选IP",
            buyNo: "购买量",
            feePerHour: "¥{0}/小时",
            feePerHours: "¥{0}/小时",
            totalPerMonth: "（合计 ¥ {0}/月）",
            targetInternetAccessName: "目标网络接口名称",
            billInfo: "计费信息",
            relativeNetworkInterface: "关联网口",
            internetAccessType: "网络接口数量",
            singleInternetAccess: "单网口",
            doubleInternetAccess: "双网口",
            targetInternetAccessName: "目标网络接口名称",
            singleInternetAccessChiefName: "主网口(bond0)",
            chiefInternetAccessName: "主网口(eth0)",
            subInternetAccessName: "辅网口(eth1)",
            targetPrivateIpAddress: "目标内网IP地址",
            arrear: "已欠费"
        },
        help: {
            doc: "弹性公网IP帮助文档",
            ipAddressSearch: "请输入IP地址搜索",
            ipIdSearch: "请输入IP ID搜索",
            createRegion:
                "创建云物理服务器EIP需与云物理服务器位于同一地域方可绑定，云物理服务器EIP一旦创建，地域属性即不可更改。",
            countLimitedByEid: "该数量受公网IP限额限制",
            countTooltip: "基于以上配置，可批量创建云物理服务器EIP的数量。",
            quotaTooltip:
                "该地域云物理服务器EIP配额已满，请提交工单申请扩大配额",
            alreadyBond: "当前云物理服务器已绑定公网IP",
            confirmToUnbind: "确认将公网IP {0} 从云物理服务器 {1}{2} 解绑?",
            confirmToUnbindSlb: "确认将公网IP {0} 从负载均衡 {1} 解绑?",
            confirmToUnbindNat: "确认将公网IP {0} 从NAT网关 {1} 解绑?",
            confirmToUnshare: "确认将弹性公网IP {0} 从共享带宽：{1}中移除吗？",
            byBandwidth: "按带宽 {0} Mbps",
            byPublicBandwidth: "共享带宽 {0} Mbps",
            soldOut: "所选地域资源限额已满，请切换地域或",
            openTicket: "提交工单",
            increaseLimit: "提升限额",
            paidByDurationDeleteNotAllowed: "包年包月资源不允许删除",
            shareDeleteNotAllowed: "已绑定共享带宽不允许删除",
            confirmToDeleteEip: "确认删除弹性公网IP：{0}？",
            knowAboutFee: "我已清楚费用问题，我同意自行删除该资源",
            boundDeleteNotAllowed: "无法删除弹性公网IP，请先解绑其绑定资源",
            joinSharedBandwidthNotAllowedModify:
                "EIP加入共享带宽后不支持修改带宽操作",
            joinSharedBandwidthNotAllowedRenew:
                "EIP加入共享带宽后不支持续费操作",
            paidByDurationJoinSharedBandwidthNotAllowed:
                "包年包月计费类型资源不支持加入共享带宽",
            targetIpAddressSearch: "请输入目标内网IP搜索",
            noChargeInfo: "无计费信息",
            bindNatDeleteNotAllowed: "已绑定NAT网关不允许删除",
            bandwidthSoldOut:
                "公网IP已售罄！咨询请联系客服400-615-1212（7*24小时），或",
            extraBandwidthSoldOut:
                "共享带宽额外上行带宽已售罄！咨询请联系客服400-615-1212（7*24小时），或",
        },
        placeholder: {
            search: {
                ipAddress: "请输入IP地址搜索",
                ipId: "请输入IP ID搜索",
                name: "请输入名称搜索",
                privateAddress: "请输入内网地址搜索",
                privateIp: "请输入内网IP地址进行搜索",
                id: "请输入ID搜索"
            }
        },
        operations: {
            unbind: {
                name: "解绑资源"
            },
            bind: {
                name: "绑定资源"
            },
            modify: {
                name: "修改带宽"
            },
            joinshared: {
                name: "加入共享带宽"
            },
            removeshared: {
                name: "移出共享带宽"
            },
            renew: {
                name: "续费"
            },
            edittag: {
                name: "编辑标签"
            },
            delete: {
                name: "删除"
            }
        }
    },
    // 共享带宽
    sbw: {
        text: {
            sbw: "共享带宽",
            apply: "申请",
            ipAddress: "IP地址",
            sharedBandwidthName: "共享带宽名称",
            sharedBandwidthId: "共享带宽ID",
            sharedBandwidthIP: "共享带宽IP",
            idOrName: "ID/名称",
            idOrAddress: "IP ID/地址",
            alreadyJoinIp: "已加入IP",
            name: "名称",
            addIp: "添加IP",
            addIpTip:
                "IP加入共享带宽后：</br>" +
                "1、原本的带宽值失效,变为和共享带宽的相同，加入后带宽：{0} Mbps;</br>" +
                "2、原来的计费模式失效，变为单纯的IP,不额外计带宽费用;</br>" +
                "3、预付费包年包月的弹性公网IP暂时不支持添加到共享带宽;</br>",
            chooseIpTip: "请选择共享带宽{0}要添加的IP",
            chooseIpTip0: "请选择共享带宽",
            chooseIpTip1: "要添加的IP",
            remainIpTip: "当前共享带宽还可添加{0}个IP",
            remainIpTip0: "当前共享带宽还可添加",
            remainIpTip1: "个IP",
            exceedTotalIpCountTip: "，该共享带宽可添加的IP已达上限，可",
            removeShareBandWidthEip: "移出共享带宽中的弹性公网IP",
            prepaid: "按固定带宽",
            postpaid: "按配置计费",
            postUsage: "按增强型95计费",
            guaranteedPercentage: "保底百分比",
            byEnhanced: "按增强型95计费 {0}Mbps",
            feePerDay: "¥{0}/天"
        },
        help: {
            doc: "共享带宽帮助文档",
            confirmToDeleteSbw: "确认删除共享带宽：{0}？",
            deleteSbwTip: "无法删除共享带宽，请先移除已加入IP。",
            addIpTip: "该共享带宽可添加的IP已达上限，可提交工单提升配额。",
            bandwidthSoldOut:
                "共享带宽带宽已售罄！咨询请联系客服400-615-1212（7*24小时），或",
            extraBandwidthSoldOut:
                "共享带宽额外上行带宽已售罄！咨询请联系客服400-615-1212（7*24小时），或",
            bothSoldOut:
                "带宽、额外上行带宽售罄，咨询请联系客服400-615-1212（7*24小时），或",
            unExceedMonth: '按用量资源未使用一个完整自然月不允许删除',
            payByEnhancedNotAllowedRenew: "按用量计费类型资源不支持续费",
        },
        placeholder: {
            search: {
                sharedBandwidthName: "请输入共享带宽名称搜索",
                sharedBandwidthId: "请输入共享带宽ID搜索"
            }
        },
        tooltip: {
            node: "不同节点内网资源不互通，创建后不可更改。",
            cal: "共享带宽使用过程中，可以随时对带宽值进行配置变更。",
            name: "指共享带宽的名称",
            count: "该数量受共享带宽配额限制",
            countTooltip: "基于以上配置，可批量创建共享带宽的数量。",
            enhanced: "购买按增强型95计费的共享带宽适用于单日内公网带宽业务流量波动较大的业务场景,单位为Mbps。",
        },
        operations: {
            addip: {
                name: "添加IP"
            },
            removeip: {
                name: "移除共享带宽"
            },
            modify: {
                name: "修改带宽"
            },
            renew: {
                name: "续费"
            },
            edittag: {
                name: "编辑标签"
            },
            delete: {
                name: "删除",
                tip: "包年包月资源不允许删除"
            }
        }
    },
    //NAT网关
    nat: {
        text: {
            createNat: "创建NAT网关",
            nat: "NAT网关",
            helpDoc: "NAT网关帮助文档",
            natName: "NAT名称",
            natId: "NAT ID",
            name: "名称",
            specificationType: "规格类型",
            maxBandwidth: "最大带宽",
            bondedEip: "已绑定EIP",
            adjustSpecification: "调整规格",
            currentSpecification: "当前规格",
            selectSpecification: "可调整规格",
            small: "小型",
            middle: "中型",
            large: "大型",
            xlarge: "超大型",
            choosedSpecification: " (SNAT最大连接数{0}万，SNAT最大新建数无限制)",
            snat: "SNAT规则",
            addSnatRule: "添加SNAT规则",
            editSnatRule: "编辑SNAT规则",
            snatId: "ID",
            snatIp: "IP",
            snatRuleId: "SNAT规则ID",
            snatRuleGranularity: "SNAT规则粒度",
            snatOriginalIp: "源网段/源IP",
            belongServer: "所属子网/所属服务器",
            eip: "弹性公网IP",
            dnat: "DNAT规则",
            addDnatRule: "添加DNAT规则",
            editDnatRule: "编辑DNAT规则",
            dnatRuleId: "DNAT规则ID",
            publicNetPort: "公网端口",
            priIpv4: "内网IPv4",
            privatePort: "内网端口",
            supportProtocol: "支持协议",
            description: "描述",
            subnetGranularity: "子网粒度",
            serverGranularity: "服务器粒度",
            customGranularity: "自定义粒度",
            subnetCidr: "主要IPv4 CIDR: {0}",
            subnetSecondaryCidr: ";次要IPv4 CIDR: {0}",
            server: "@:listPage.speechCraft.title",
            customCidr: "自定义网段",
            portType: "端口类型",
            allPort: "所有端口",
            specific: "具体端口",
            boundRules: "已绑定规则",
            snat: "SNAT",
            dnat: "DNAT"
        },
        speechCraft: {
            deteteNatTip:
                "删除NAT网关会解绑其弹性IP地址关联。但不会从您的账户释放该地址。如果不想继续使用弹性公网IP，为避免产生费用，请及时登录控制台删除资源。",
            sureDeleteNat: "确认删除NAT网关：{0}吗？",
            bindEipCount1: " 当前NAT网关还可绑定",
            bindEipCount2: "个弹性公网IP",
            natTip: "NAT网关最多可绑定20个同地域弹性公网IP",
            maxLinkTip:
                "SNAT最大连接数：小型5万，中型20万，大型50万，超大型100万",
            maxNewTip: "SNAT最大新建数：不同规格的NAT网关无限制",
            natTypeTip:
                "不同规格的NAT网关会影响SNAT最大连接数（不同规格的NAT网关SNAT最大新建数无限制）。网关配置EIP数会限制了NAT网关最大连接数NAT网关绑定单EIP最大连接数为55000，绑定多EIP时最大连接数为55000xN。",
            limitEipTip:
                "NAT网关最多可绑定20个弹性公网IP, 当前NAT网关所绑定弹性公网IP已达上限",
            natlimit: "，该NAT网关所绑定弹性公网IP已达上限",
            deleteSnatRuleTip: "删除SNAT规则会导致对应的云物理服务器实例无法访问公网并无法恢复，请谨慎操作。",
            sureDeleteSnatRuleTip: "确认删除SNAT规则吗？",
            sureDeleteDnatRuleTip: "确认删除DNAT规则吗？"
        },
        operations: {
            bind: {
                name: "绑定资源"
            },
            modify: {
                name: "调整规格"
            },
            renew: {
                name: "续费"
            },
            delete: {
                name: "删除"
            },
            edit: {
                name: "编辑"
            }
        },
        help: {
            natOverStock: "NAT网关超过购买配额!",
            customCidr: "请输入合法且标准的自定义网段",
            snatRule: "同一个NAT实例下支持创建{0}条SNAT规则",
            dnatRule: "同一个NAT实例下支持创建{0}条DNAT规则"
        },
        az: {
            azNameA: "可用区A",
            azNameB: "可用区B",
            azNameC: "可用区C"
        },
        placeholder: {
            snatIp: "请输入IP进行搜索",
            eip: "请选择公网IP",
            notEip: "--无可用公网IP--",
            emptyInstance: "--无可用实例--",
            server: "请输入实例目标内网IP地址搜索",
            customCidr: "示例:10.0.1.1/24 或/32",
        },
    },
    // 对等连接
    peering: {
        text: {
            connection: "对等连接",
            create: "创建",
            peeringName: "对等连接名称",
            peeringId: "对等连接ID",
            status: "状态",
            localTerminalInfo: "本端信息",
            oppositeTerminalInfo: "对端信息",
            name: "名称",
            localRegion: "本端地域",
            localVpc: "本端私有网络",
            localVpcIpv4Cidr: "本端私有网络IPV4 CIDR",
            localVpcIpv6Cidr: "本端私有网络IPV6 CIDR",
            oppositeAccountType: "对端账号类型",
            sameAccount: "同账号",
            differentAccount: "跨账号",
            sender: "发送方",
            receiver: "接收方",
            oppositeAccountNumber: "对端账号",
            oppositeRegion: "对端地域",
            oppositeVpc: "对端私有网络",
            chooseOppositeVpc: "请选择对端VPC",
            oppositeVpcIpv4Cidr: "对端私有网络IPV4 CIDR",
            oppositeVpcIpv6Cidr: "对端私有网络IPV6 CIDR",
            localRouteStrategy: "路由策略(本端)",
            oppositeRouteStrategy: "路由策略(对端)",
            bandwidth: "带宽",
            constBandWidth: "按固定带宽",
            free: "免费",
            noLimit: "不限制",
            byBandwidth: "{0}Mbps 按固定带宽计费",
            monthPay: "(按配置月费用合计￥{0}/月)",
            exceedQuota: "超过购买配额!",
            createTime: "创建时间",
            routeId: "路由ID/名称",
            destination: "目的端",
            nextHopType: "下一跳类型",
            nextHop: "下一跳",
            reject: "拒绝",
            accept: "接受",
            delete: "删除",
            paymentByInitiator: "发起方付费"
        },
        help: {
            doc: "对等连接帮助文档",
            hasNoCpsVip: "当前账号未打标签不能创建按配置计费资源，请",
            submitWorkOrder: "提交工单",
            applyCpsVip: "申请打标后再进行创建对等连接 ",
            acceptConnect: "对端账号需要在{0}前接受此次请求",
            ipv4CidrIsOverlap: "新peering的VPC CIDR有重叠，无法建立连接"
        },
        placeholder: {
            search: {
                peeringName: "请输入对等连接名称搜索",
                peeringId: "请输入对等连接ID搜索"
            },
            oppositeVpcId: "请输入对端VPC ID",
            oppositeAccountNumber: "请输入对端主账号ID"
        },
        tooltip: {
            region: "不同地域内网资源不互通，创建后不可更改。",
            name: "指对等连接的名称。",
            accountType:
                "同账号:指创建同一帐户下的对等连接。跨账号:创建不同帐户下的对等连接。",
            oppositeAccountNumber:
                "对端账号指主账号ID，在账号管理-账号与权限。",
            bandWidth: "购买固定带宽类型，适用于网络情况较稳定的业务场景。"
        },
        speechCraft: {
            sureDelete: {
                isSameRegion:
                    "确认删除对等连接：{0}吗？删除后，路由表中包含该对等连接的路由将一并删除。",
                isDiffRegionSameTenant:
                    "确认删除对等连接: {0}吗？删除后，路由表中包含该对等连接的路由将一并删除，且对等连接不再继续计费。",
                isDiffRegionDiffTenant:
                    "确认删除对等连接: {0}吗?删除后，路由表中包含该对等连接的路由将一并删除，且发起端对等连接不再继续计费。"
            },
            sureAccept:
                "确认接受该对等连接: {0}吗?接受后，私有网络的路由自动下发配置，私有网络之间可相互访问。",
            sureReject: "确认拒绝该对等连接: {0}吗?",
            acceptTitle: "接受对等连接",
            rejectTitle: "拒绝对等连接",
            deleteTitle: "删除对等连接"
        },
        operations: {
            modify: {
                name: "修改带宽"
            },
            delete: {
                name: "删除"
            },
            accept: {
                name: "接受"
            },
            reject: {
                name: "拒绝"
            }
        }
    },
    // 私有网络
    privateNetwork: {
        osNotPass: " ",
        regionOne: "华北-北京",
        regionTwo: "华东-宿迁",
        privateNetwork: "私有网络",
        create: "创建",
        createTitle: "创建私有网络",
        region: "地域",
        regionTip: "创建私有网络",
        createTip: "不同地域资源的VPC默认不互通，创建后不可更改",
        notChange: "创建后不可修改",
        cidrTip:
            "同一可用区下，用户仅在创建第一台云物理服务器时可以配置内网网段，内网网段创建后不可修改，后续购买的云物理服务器默认使用该内网网段。如果用户在该可用区下的所有云物理服务器均已被回收，再次购买第一台云物理服务器时可重新配置内网网段。建议用户创建云物理服务器前做好网络规划。",
        name: "名称",
        nameHelp:
            "1-32字符，只允许中文、数字、大小写字母、英文下划线“_”及中划线“-”。",
        segment: "IPv4 CIDR",
        ipv6Cidr: "IPv6 CIDR",
        ipv6CidrHelp: "为后续开通IPv6公网访问服务，系统自动创建IPv6互联网网关",
        open: "开通",
        close: "未开通",
        openIpv6: "开通IPv6",
        description: "描述",
        descriptionHelp: "长度不超过256字符",
        sure: "确定",
        cancel: "取消",
        delete: "删除",
        delTitle: "删除私有网络",
        delConfirm: "确认删除私有网络: {0}?",
        privateHelpDoc: "私有网络帮助文档",
        operate: "操作",
        deleteTip: "无法删除该私有网络，请先删除该私有网络内的子网",
        deleteForPeering: "无法删除该私有网络，请先解除绑定关系",
        deleteWithIpv6CidrTip: "",
        sourceInfo: "资源信息",
        subnet: "子网",
        baseInfo: "基本信息",
        configInfo: "配置信息",
        id: "ID",
        copySuccess: "复制成功",
        copy: "复制",
        editName: "修改名称",
        editDescription: "修改描述",
        nameNotNull: "名称不能为空",
        nameNotPass: " ",
        desNotPass: " ",
        passwordNotNull: "密码不能为空",
        passwordNotPass: "请输入合规密码",
        repasswordNotNull: "确认密码不能为空",
        repasswordNotPass: "确认密码与密码不相同",
        selectOs: "请选择系统版本",
        tableTitle: {
            name: "名称",
            cidr: "IPv4 CIDR",
            ipv6Cidr: "IPv6 CIDR",
            subNet: "子网",
            createTime: "创建时间",
            operate: "操作",
            ratio: "可用IP/总IP"
        },
        searchTip: "请输入名称搜索",
        area: "地域",
        createTime: "创建时间",
        onlyOnePrivateNet: "同一地域下仅支持创建一个私有网络",
        delPrivateNetworkTip:
            "删除VPC自动删除关联的IPv6互联网网关，且VPC IPv6 CIDR将回收且不可找回，请谨慎操作!",
        openPrivateNetworkIpv6Tip:
            "开通后系统将为您自动创建一个IPv6网段，并免费创建一个IPv6互联网网关。",
        openPrivateNetworkIpv6Confirm: "确认开通私有网络：{0} 的IPv6功能吗？",
        vpcCidr: "VPC IPv4 CIDR",
        vpcIpv6Cidr: "VPC IPv6 CIDR",
        noSuitableKey: "如无合适密钥可以",
        defaultGameVpcTip: "如需删除请提交工单(提供工单url:https://jrgd.jdcloud.com/applyorder/from?lobId=002s00080001)",
    },
    // 私有网络实例列表
    privateNetInstance: {
        emptyKeyPair: '请选择密钥',
        initKeyPair: "初始密钥",
        loginKeyPair: "登录密钥",
        SOSKeyPair: "SOS密钥",
        outConsole: "带外控制台",
        sosTip: "获取SOS带外控制台访问方式",
        fixSOSTip:
            "通过修复SOS，选择SSH密钥后会自动与对应实例关联绑定，可获取SOS带外控制台访问方式。",
        sosKeyTip: "该密钥为访问SOS带外控制台时的密钥",
        initPairTip: "该密钥仅为创建或者重装系统时的初始密钥。",
        keyPairTip: "当前仅支持云物理服务器重装系统时绑定密钥。",
        bindSure: "确定",
        auto: "自动分配",
        handwrite: "手动分配",
        autoIPv4: "自动分配IPv4",
        handwriteIPv4: "手动分配IPv4",
        operateSuccess: "操作成功",
        operateFail: "操作失败",
        changeNet: "更换网络",
        empty: " ",
        operations: {
            rePassword: "重置密码",
            reOperateSystem: "重装系统",
            reVpcnetWork: "更换私有网络",
            reSubnetwork: "更换子网",
            reIntranetIp: "更换内网IP",
            ipv6: "开通IPv6",
            onlyOneIpv6: "实例最多支持1个IPv6地址",
            repay: "续费",
            makeMirror: "制作镜像",
            bind: "绑定弹性公网IP",
            unbind: "解绑弹性公网IP",
            sos: "SOS",
            fixSOS: "修复SOS",
            resetSOS: "重置SOS",
            notWindows: "仅Linux OS支持",
            onlyShutDown: "仅在关机状态下支持",
            onlyRunning: "仅在运行状态下支持",
            onlyNotError: "仅关机/运行状态支持",
            alreadyHaveIPv6: "已分配IPv6地址的实例不允许更换网络",
            alreadyHaveNatRules: "已关联 DNAT、 SNAT 规则的实例不允许修改网络配置，请先删除 SNAT/DNAT规则。",
            alreadyBindEip: "已绑定EIP的实例不允许更换网络，请先解绑EIP",
            alreadyBindOtherIp:
                "已绑定别名IP的实例不允许更换网络 ，请先解绑别名IP",
            alreadyAddLb:
                "已加入负载后端服务器组的实例不允许更换网络，请先从负载均衡RS中移出",
            onlySubmit:
                "十分抱歉！重置密码暂时不支持线上操作您可以提交工单或联系客服",
            overdueTip: "已到期/欠费/停服的实例不支持该操作",
            wrongDeviceType: "定制机型不支持制作镜像",
        },
        types: {
            compute: "计算型",
            storage: "存储型",
            gpu: "GPU"
        },
        statueNames: {
            creating: "创建中",
            starting: "开机中",
            running: "运行",
            stopping: "关机中",
            stopped: "关机",
            restarting: "重启中",
            error: "错误",
            upgrading: "调整配置中",
            reinstalling: "重装系统中",
            destroying: "销毁中",
            inconfig: "配置中",
            resetting_password: "重置密码中",
            making: "制作中",
        },
        reinstallCheck: "我已知晓以上风险",
        haveSOS: "获取SOS带外控制台访问方式",
        SOScontent: "在终端中使用以下命令访问该服务器的带外控制台：",
        fixSOS: "修复SOS带外控制台",
        resetSOS: "重置SOS带外控制台",
        fornowSOS: "当前绑定密钥：",
        fixSOSTips1:
            "SOS带外控制台功能已于2021年7月1日正式上线，2021年7月1日之前创建的实例，需自动重装或手动修复SOS才能访问带外控制台。详见",
        fixSOSTips2:
            "选择SSH密钥后会自动与对应实例关联绑定，可获取SOS带外控制台访问方式",
        sshName: "密钥名称",
        ipTip: "内网全部开放，公网开放22端口（远程SSH登录）",
        currentNetworkMessage: "当前网口信息",
        targetNetworkMessage: "目标网络信息",
        notIpTip: "内网全部开放",
        notVPC: "--无可用VPC网络--",
        notSubnet: "--无可用子网--",
        chooseVPC: "请选择VPC",
        chooseTargetVPC: "请选择目标私有网络",
        chooseSubnet: "请选择子网",
        chooseTargetSubnet: "请选择目标子网",
        autoIpTip: " 系统将自动分配",
        notAutoIpTip: " 请输入IPv4地址",
        notAutoIpv6Tip: " 请输入IPv6地址",
        hostname: "主机名",
        hostInfo: "主机信息",
        chargeMethod: "计费方式",
        soldOut: "售罄",
        manager: "管理员",
        manageTip: "可选填，操作系统内部的计算机名",
        formatDataDisk: "同时格式化所有数据盘",
        hostHint:
            '2-60 个字符，允许使用大小写字母、数字、连字符 "-"，不能连续使用 "-"，"-"不能用于开头或结尾。',
        hostnameTip:
            "主机名是指云物理服务器操作系统内部的计算机名，用户可以自定义设置，云物理服务器成功生产后可以通过登录云物理服务器内部查看。一次购买多台云物理服务器的情况下，默认在设置名称后面加上数字，以递增的形式来标志多台云物理服务器。",
        public: "(公网IPv4)",
        private: "(内网IPv4)",
        ipv6Address: "(内网IPv6)",
        submit: "提交工单",
        openTitle: "开机提示",
        closeTitle: "关机提示",
        restartTitle: "重启提示",
        repasswordTip: "重置密码提示",
        closeTip: "确认关闭云物理服务器{0}",
        openTip: "确认开启云物理服务器{0}",
        restartTip: "确认重启云物理服务器{0}",
        reInstallTitle: "重装系统",
        reInstallTip1:
            "<strong>重装系统须知：</strong></br>" +
            "1、重装系统针对系统盘做初始化、更换操作系统操作。</br>" +
            "2、该操作会清空云物理服务器系统盘内数据，请您做好备份，若由于未备份造成的数据丢失，京东云概不负责。</br>" +
            "3、如果选择格式化数据盘数据，数据盘数据也将同时被清空。重装系统需要重新加载已挂载的数据盘。</br>" +
            "4、如果选择不格式化数据盘，重装系统后数据盘需要重新挂载，如果挂载点与系统盘重复则挂载不成功，请您重新挂载使用。</br>" +
            "5、重装系统后已安装的监控插件将自动卸载，请您重新安装使用。</br>",
        reInstallTip2:
            "6、重装系统后，系统默认不会为实例配置 IPv6 地址，您需要手工进行配置。",
        renetworkTip:
            "注意：</br>" +
            "1、已加入负载均衡后端服务器组中的实例不允许修改网络配置，如需修改请先从后端服务器组中移除。</br>" +
            "2、已绑定别名IP的实例不允许修改网路配置，如需修改请先解绑实例（ 单网口，双网口） 的所有别名IP。</br>" +
            "3、已分配 IPv6 地址的实例不可更改网络配置。</br>" +
            "4、已绑定EIP的实例不允许修改网络配置，如需修改请先解绑EIP。</br>" +
            "5、已关联 DNAT、SNAT 规则的实例不允许修改网络配置，如需修改请先删除 SNAT/DNAT 规则。",
        batchRepassordTips:
            "注意：</br>" +
            "1、通过此方式重置密码的多台实例密码均相同 </br>" +
            "2、重置实例密码后，只有在控制台对实例进行开机才能生效 </br>",
        batchRenameTips: "注意：通过此方式编辑的多台实例名称均相同",
        batchDeleteTips:
            "注意：</br>" +
            "1、云物理服务器删除后所有数据将被清除且不可恢复，请提前备份数据；</br>" +
            "2、云物理服务器删除时，负载均衡的虚拟服务器组中的资源也会删除；但是所绑定的弹性公网IP将继续保留，如不需要保留，请前往对应页面删除，以免产生额外费用。</br>",
        changeNetworkTips:
            "如果您在创建实例时选错VPC或者需要重新规划网络，可以通过更换单个CPS的 VPC、子网、内网IP功能。</br>" +
            "以下场景不支持开启更换网络：</br>" +
            "①已加入负载均衡后端服务器组中的实例不允许修改网络配置，如需修改请先从后端服务器组中移除。</br>" +
            "②已绑定别名 IP 的实例不允许修改网路配置，如需修改请先解绑实例（ 单网口，双网口）的所有别名 IP。</br>" +
            "③已分配 IPv6 地址的实例不可更改网络配置。</br>" +
            "④已绑定 EIP 的实例不允许修改网络配置，如需修改请先解绑 EIP。",
        showDetails: "查看详情",
        putaway: "收起",
        open: "开机",
        payNow: "立即支付",
        shouldPay: "应付金额",
        clause: "《云物理服务器服务条款》",
        readAndAgree: "我已阅读并同意",
        firstStep: "第一步",
        secondStep: "第二步",
        thirdStep: "第三步",
        orderConfirm: "订单确认",
        payConfirm: "支付确认",
        payFinish: "支付完成",
        orderTip: "为保证您的正常使用，包年包月资源在到期前不支持删除。",
        orderInfo: "订单信息",
        productType: "产品类型",
        spcDetail: "配置详情",
        calculating: "计算中...",
        constPayments: "按固定带宽",
        standardMirror: "标准镜像",
        compute: "计算",
        gpu: "GPU",
        configTip: "根据具体业务情况选择不同云物理服务器规格类型，可参考",
        autoShowTip: "{0}区间内自动分配IPv4",
        byBandwidth: "{0} 按带宽 {number} Mbps",
        configDetail: "规格详情",
        firewallTip: "防火墙设置请参考",
        cancel: "取消",
        sure: "确定",
        unBindTitle: "解绑弹性公网IP",
        sureUnBindTip: "确认解绑弹性公网IP: {0}?",
        bindTitle: "绑定弹性公网IP",
        chooseBindTip: '请选择"{0}"要绑定的弹性公网IP',
        tableTitle: {
            ip: "IP地址",
            bandWidth: "带宽",
            region: "可用区"
        },
        cps: "云物理服务器",
        baseInfo: "基本信息",
        configInfo: "配置信息",
        networkInfo: "网络信息",
        sourceInfo: "资源信息",
        hardWareMonitor: "硬件监控",
        running: "运行",
        helpDoc: "云物理服务器帮助文档",
        id: "ID",
        name: "名称",
        description: "描述",
        monthAndYear: "包年包月",
        discount: "优惠",
        regionAndArea: "地域与可用区",
        region: "地域",
        valArea: "可用区",
        agent: {
            status: "Agent状态",
            normal: "正常",
            abnormal: "异常",
            installWarn: "安装及卸载agent请参考{link}",
            guide: "操作指南",
            installWarn2: "免费安装{link}",
            installWarnWindows: "Windows暂不支持性能监控",
            plugin: "监控插件"
        },
        regionTip: "不同地域资源内网不互通，创建后不可更改。",
        config: "配置",
        series: "系列",
        type: "机型",
        mirror: "镜像",
        mirrorType: "镜像类型",
        operateSystem: "操作系统",
        systemVersion: "系统版本",
        storage: "存储",
        sysDisk: "系统盘",
        dataDisk: "数据盘",
        sysDiskTip:
            "系统盘若为一块硬盘，则自动配置为NO RAID。系统盘为两块硬盘，则自动配置为RAID1。",
        network: "网络",
        createPrivateNetwork: "创建私有网络",
        createSubNet: "创建子网",
        privateNet: "私有网络",
        targetPrivateNet: "目标私有网络",
        privateNetCidr: "IPv4 CIDR: {0}",
        privateNetIpv6Cidr: ",IPv6 CIDR: {0}",
        subnet: "子网",
        targetSubnet: "目标子网",
        intranetIp: "内网IP",
        targetIntranetIp: "目标内网IP",
        intranetIpTip: "将在{0}区间内自动分配IPv4。",
        intranetIpv6Tip: "将在{0}区间内自动分配IPv6。",
        internetIpTipTwo:
            "若选择手动分配IP，请在{0}区间内指定IPv4，暂不支持批量创建云物理服务器",
        internetIpv6TipTwo:
            "若选择手动分配IP，请在{0}区间内指定ipv6，暂不支持批量创建云物理服务器",
        internetIpTipTwo1: "请在{0}区间内手动分配IPv4。",
        autoAllocationTip: '您选择“自动分配 IPv4”方式后，系统会随机分配一个 IPv4 地址为您更换网络，请谨慎操作。',
        firewall: "防火墙",
        bandwidth: "带宽",
        internetIpWarning:
            "如果不购买公网IP，您将不能从公网访问云物理服务器。公网IP不支持后期添加",
        internetIpTitle: "注意",
        read: "已阅读并同意",
        tip: "提示",
        buyIp: "购买弹性IP",
        username: "用户名",
        password: "密码",
        repassword: "确认密码",
        instanceNameTip:
            "1-32字符，只允许中文、数字、大小写字母、英文下划线“_”及中划线“-”。",
        descriptionTip: "长度不超过256字符",
        passwordTip:
            "8-30个字符，且同时包含三项（大写字母，小写字母，数字或特殊符号()`~!@#$%&*_-+=|{}[]:\";'<>,.?/）。",
        count: "购买数量",
        selectedConfig: "已选配置",
        buyNow: "立即购买",
        spec: "规格",
        interNetwork: "内网IP",
        publicNetIp: "公网IP",
        duration: "购买时长",
        charge: "费用",
        create: "创建",
        input: "请输入内容",
        instanceID: "实例ID",
        instanceName: "实例名称",
        shutdown: "关机",
        restart: "重启",
        error: "错误",
        clickCommit: "点击提交工单",
        more: "更多",
        chargeType: "计费类型",
        createTime: "创建时间",
        expireTime: "到期时间",
        networkType: "网络类型",
        netBelongs: "所属网络",
        publicNetBandwidth: "公网带宽",
        fireWall: "防火墙",
        defaultFireWall: "默认Linux开放22端口",
        operateGuid: "操作指南",
        onlyShutDown: "仅关机状态支持",
        onlyRunning: "仅运行状态支持",
        operate: "操作",
        listTitle: {
            name: "ID/实例名称",
            monitor: "监控",
            region: "可用区",
            ipAddress: "IP地址",
            privateAndSub: "私有网络/子网",
            netType: "网络类型",
            status: "状态",
            spc: "规格类型",
            config: "配置",
            charge: "计费信息",
            operate: "操作",
            createTime: "创建时间",
            cidr: "CIDR",
            subnet: "子网",
            onlyName: "名称"
        },
        configListTitle: {
            spcType: "规格类型",
            spc: "规格",
            cpu: "CPU",
            memory: "内存",
            netCard: "网卡",
            GPU: "gpu"
        },
        placeholderId: "请输入ID进行搜索",
        placeholderName: "请输入名称进行搜索",
        monthLabel: "个月",
        yearLabel: "年",
        oneYear: "1年",
        twoYear: "2年",
        threeYear: "3年",
        oneYearCountLabel: "1年云物理服务器享8.3折优惠",
        twoYearCountLabel: "2年云物理服务器享8.3折优惠",
        threeYearCountLabel: "3年云物理服务器享8.3折优惠",
        buyTime: "购买时长",
        counts: "数量",
        buyCountTip: "单次订单最大购买数量为5台,如需扩容，请联系客服或{0}",
        arrear: "已欠费",
        subnetBelongTo: "所属子网",
        subnetIpv6Cidr: "子网IPv6 CIDR",
        enableIpv6Tip: "当前网口最多支持分配1个IPv6地址",
        isEnableIPv6: "是否开通IPv6公网",
        hasEnabledIPv6: "已开通",
        hasDisabledIPv6: "未开通",
        enablePublicNet: "(去开通公网)",
        sosSecretKeyTipPart1: "1.该密钥为访问 SOS 带外控制台的密钥。",
        sosSecretKeyTipPart2: "2.需用户手动修改密码才可访问 SOS 带外控制台。",
        turnOnDeleteProtectTip: "确认将实例{0}开启实例删除保护？",
        turnOffDeleteProtectTip: "确认将实例{0}关闭实例删除保护？",
        deleteProtect: "实例删除保护",
        deleteProtectOn: "已开启",
        deleteProtectOff: "已关闭",
        instanceInfo: "实例信息",
        instanceConfig: "实例配置",
        mirrorInfo: "镜像信息",
        // gpuMonitoring: { // GUP监控相关文案
        //     gpuMemoryTotal: "GPU 总显存",
        //     gpuUtilization: "GPU 使用率",
        //     gpuMemoryUsed: "GPU 显存使用量",
        //     gpuMemoryUtilization: "GPU 显存使用率"
        // }
    },
    // 镜像
    mirror: {
        text: {
            title: "镜像",
            mirrorIdAndName: "ID/镜像名称",
            allStatus: "全部",
            availableStatus: "可用",
            errorStatus: "错误",
            mirrorType: "镜像类型",
            architecture: "体系架构",
            osType: "操作系统平台",
            systemVersion: "操作系统版本",
            createTime: "创建时间",
            mirrorId: "镜像ID",
            mirrorName: "镜像名称",
            doc: "镜像帮助文档",
            createInstance: "创建实例",
            commonMirror: "公共/定制镜像",
            publicMirror: "公共镜像",
            customizeMirror: "定制镜像",
            privateMirror: "私有镜像",
            importMirror: "导入镜像"
        },
        tips: {
            search: {
                mirrorId: "请输入镜像ID精确查询",
                mirrorName: "请输入镜像名称模糊查询",
            },
            createdInstanceDeleteNotAllowed: "无法删除私有镜像，请先删除该镜像下的资源",
            deleteMirror: "确认删除该镜像吗？镜像信息如下：",
        },
        operations: {
            delete: {
                name: "删除"
            },
            create: {
                name: "创建实例"
            }
        }
    },
    // 重置密码
    passwordReset: {
        sentence: "注意：重置实例密码后，只有在控制台对实例进行开机才能生效。",
        newPassword: "新密码"
    },
    // 负载均衡
    slb: {
        operations: {
            edit: { name: "编辑" },
            open: { name: "开启" },
            close: { name: "关闭" },
            delete: { name: "删除" }
        },
        text: {
            allAz: "全可用区",
            unbindPublicIp: "解绑公网IP",
            renew: "续费",
            id: "ID",
            publicNetBandwidth: "公网带宽",
            delete: "删除",
            slb: "负载均衡",
            slbId: "实例ID",
            slbName: "实例名称",
            listener: "监听器",
            createListener: "创建监听器",
            name: "名称",
            protocolPort: "监听协议：端口",
            opened: "开启",
            running: "运行",
            closed: "关闭",
            algorithm: "调度算法",
            roundRobin: "加权轮询",
            leastConnections: "加权最小连接数",
            ipHash: "IP哈希",
            conhash: "源IP",
            stickySession: "会话保持",
            stickySessionTimeout: "会话保持超时",
            sessionType: "会话类型",
            setCookie: "植入cookie",
            rewriteCookie: "重写cookie",
            httpHeader: "获取HTTP头字段",
            domain: "域名",
            certificate: "证书",
            healthCheck: "健康检查",
            defaultServerGroup: "默认服务器组",
            stopped: "停止",
            active: "运行",
            edit: "编辑",
            slbHelpDoc: "负载均衡帮助文档",
            protocol: "监听协议",
            port: "端口",
            http2: "HTTP 2.0",
            realIp: "获取真实IP",
            createCertificate: "创建证书",
            healthCheckTimeout: "响应超时时间",
            healthCheckInterval: "健康检查间隔",
            healthCheckThreshold: "健康阈值",
            times: "{0}次",
            unhealthyCheckThreshold: "不健康阈值",
            healthCheckUri: "检查路径",
            healthCheckHttpCode: "正常态码",
            serverGroup: "服务器组",
            relatedServerGroup: "关联后端服务器组",
            healthCheckIp: "健康检查IP",
            openListener: "开启监听器",
            closeListener: "关闭监听器",
            deleteListener: "删除监听器",
            bandwidth: "带宽上限",
            publicNet: "公网",
            ipv4: "IPv4",
            cps: "云物理服务器",
            netType: "网络类型",
            ipVersion: "IP版本",
            privateNetwork: "私有网络",
            bindServerType: "绑定服务器类型",
            baseInfo: "基本信息",
            instanceName: "实例名称",
            description: "描述",
            publicIp: "公网IP",
            bandwidthCalModel: "带宽计费模式",
            lineType: "线路",
            maxBandWidth: "带宽上限",
            constBandWidth: "按固定带宽",
            bgp: "BGP",
            buyEip: "购买弹性公网IP",
            detail: "详情介绍>>",
            publicIpInfo: "{0} 按带宽 {1}Mbps",
            createPrivateNet: "创建私有网络",
            baseConfig: "基本配置",
            protocolAndPort: "监听协议及端口",
            backendServer: "后端服务器",
            chooseBackendServer: "选择后端服务器",
            chooseBackendGroup: "选择服务器组",
            addServer: "添加服务器",
            addServerGroup: "添加服务器组",
            openSlb: "开启负载均衡",
            network: "网络",
            sourceFee: "资源费用",
            configFee: "配置费用",
            closeSlb: "关闭负载均衡",
            listenerNumber: "监听器数量",
            addListener: "添加监听",
            bindPublicIp: "绑定公网IP",
            healthyStatus: "健康状态",
            backendServerGroups: "后端服务器组",
            editListener: "编辑监听器",
            timeCount: "次",
            associatedMonitor: "关联监听",
            cert: "证书",
            certContent: "证书内容",
            monitorProtocol: "监听协议:端口",
            associatedMonitoring: "关联监听器",
            createCert: "创建证书",
            addCert: "添加证书",
            deleteCert: "删除证书",
            subKey: "私钥",
            example: "样例参考",
            sni: "SNI管理",
            addDomain: "添加扩展域名",
            editDomain: "编辑扩展域名",
            accessControl: "访问控制",
            manageStrategy: "管理策略",
            ruleType: "规则类型",
            priority: "优先级",
            ipAddressOrCidr: "IP地址/地址段",
            blackList: "黑名单",
            whiteList: "白名单",
            addOneAcl: "添加一条策略",
            customSetting: "个性化设置",
            codeAllocation: "代码配置"
        },
        sentence: {
            inputDomain: "请输入域名",
            chooseCertificate: "请选择证书",
            deleteVirtualServerGroupTip:
                "确认删除虚拟服务器组:{0}？删除组后会同时删除组内所有资源。",
            weightTip: " ",
            fullTip: "该地域资源限额已满，请切换地域或提交工单提升限额",
            publicIpTip:
                "支持暂不购买EIP，可在负载均衡创建完成后另行购买再绑定。",
            instanceNameTip:
                "1-32字符，只允许中文、数字、大小写字母、英文下划线“_”及中划线“-”。",
            descriptionTip: "长度不超过256字符",
            soldOut: "所选地域负载均衡资源限额已满，请切换地域或",
            openTicket: "提交工单",
            increaseLimit: "提升限额",
            open: "确认开启监听器：{0}？",
            close: "确认关闭监听器：{0}？",
            delete: "确认删除监听器：{0}？",
            sureDeleteCert: "确定要删除证书: {0}吗?",
            deleteWarning: "删除证书请先删除关联的监听",
            cannotDelete: "无法删除该证书，请先删除关联的监听",
            deleteInfo:
                "监听器删除后，相应的后端服务器也将与此监听器解除绑定关系。",
            protocolAndPort:
                "监听规则创建后，监听协议、端口不允许修改。负载均衡对外提供端口通常TCP/HTTP使用80, HTTPS使用443。",
            roundRobin:
                "加权轮询会将访问请求依序分发后端服务器，权重值越高的后端服务器，被轮询到的次数（概率）也越高。",
            leastConnections:
                "除了根据每台后端服务器设定的权重值来进行轮询，同时还考虑后端服务器的实际负载（即连接数）。当权重值相同时，当前连接数越小的后端服务器被轮询到的次数（概率）也越高。",
            ipHash:
                "每个请求按访问负载均衡的客户端IP进行哈希分配，来自同一个客户端的请求会被分发给同一个后端服务器。",
            conhash:
                "基于源IP地址的一致性hash，相同的源地址会调度到相同的后端服务器。",
            stickySession:
                "开启会话保持可以将同一客户端的请求始终转发给同一服务器。",
            stickySessionTimeout: "时长设置范围:30-3600",
            realIp:
                "用户开启该功能前请确保在后端服务器上已做完相关配置，否则可能导致无法正常工作，详见",
            healthCheckTimeout: "2~60s，响应超时时间必须小于健康检查间隔",
            healthCheckTimeoutPart1: "2~60s",
            healthCheckTimeoutPart2: "响应超时时间必须小于健康检查间隔",
            healthCheckInterval: "范围5~300",
            healthCheckIntervalPart1: "范围5~300",
            healthCheckIntervalPart2: "响应超时时间必须小于健康检查间隔",
            healthyThreshold: "范围1~10",
            unhealthyThreshold: "范围1~10",
            port: "范围：1-65535",
            portPart1: "范围：1-65535",
            portPart2: "同一负载均衡实例下的监听端口不可重复",
            openSlb: "确认开启负载均衡：{0}？",
            closeSlb: "确认关闭负载均衡：{0}？",
            overQuota: "所选地域资源限额已满，请切换地域或",
            eipExceedQuota: "EIP超过购买配额!",
            contact: "咨询请联系客服400-615-1212（7*24小时），或",
            overEipQuota: "所选地域EIP资源限额已满，请切换地域或",
            ipSearch: "请输入IP地址搜索",
            idSearch: "请输入实例ID搜索",
            nameSearch: "请输入实例名称搜索",
            bindEipNecessary: "绑定弹性公网IP后才可以开启",
            moreThan50: "同一个负载均衡实例下仅支持创建50个监听器",
            moreThan100: "每个地域下最多上传100个证书",
            deleteSlbTip:
                "注意:</br>" +
                "1、负载均衡删除后，所关联的监听器、虚拟服务器组均删除，且不可恢复;</br>" +
                "2、负载均衡删除后，后端云物理服务器将继续保留，如不需保留，请前往对应页面删除， 以免产生额外费用。",
            sureCharge:
                "我已清楚费用问题，我同意自行删除关联的监听器、虚拟服务器组",
            deleteSlbChecnkWarning: "确认删除负载均衡 ：{0}?",
            deleteDomainTip: "确认删除该扩展域名吗?",
            forbiddenEmportyDomain: "域名不能为空",
            domainNotStandardTip: "请输入合法域名",
            domainRepeatTip: "同一个域名最多只能选择一个证书",
            domainTotalTip: "1条监听器可配置的扩展域名为20",
            customSettingTip: "一条监听器可配置一个个性化配置项",
            aclIpTip: "请输入单个IP地址/地址段",
            deleteStrategyTip:
                "确认要删除该条策略吗?删除后将与该监听器解除关联，请谨慎操作!",
            closeCustomSetting:
                "确认关闭个性化设置吗?关闭后directives配置会初始化。",
            ruleTypeTip: "请选择规则类型",
            forbiddenEmportyIp: "IP地址/地址段不能为空",
            legalIpRequire: "请输入合法IP地址/地址段"
        },
        tooltip: {
            priorityTip:
                "按顺序匹配（从编号最小的规则开始，编号越小优先级越高）",
            countLimit: "同一个负载均衡实例下仅支持创建50个虚拟服务器组",
            regionTip: "不同地域资源内网不互通，创建后不可更改。",
            calModel:
                "购买固定带宽类型公网IP根据用户所选公网出带宽上限计费，单位为Mbps，适用于网络情况较稳定的业务场景。",
            bgp: "BGP网络可提供更高的访问速度。",
            boundSlb: "当前负载均衡已绑定公网IP",
            certNull: "证书内容不能为空",
            privateKeyNull: "私钥不能为空",
            netTypeTip: "提供需要被公网访问的负载均衡服务。",
            stickySessionTimeout:
                "当超过保持时间，连接内无新的请求，将会自动断开会话保持",
            httpHeaderForTip: "通过X-Forwarded-For字段获取客户端真实IP",
            httpHeaderForProto: "通过X-Forwarded-Proto字段获取负载均衡监听协议",
            httpHeaderForPort: "通过X-Forwarded-Port字段获取负载均衡监听端口",
            httpHeaderForLbip: "通过X-Forwarded-LBIP字段获取负载均衡的公网IP",
            healthCheckTimeout: "每次健康检查响应的最大时间。",
            healthCheckInterval: "进行健康检查的时间间隔。",
            healthyThreshold: "表示后端实例从失败到成功的连接健康次数。",
            unhealthyThreshold:
                "表示后端实例从成功到失败的连接健康检查失败次数。",
            healthCheckUri:
                '健康检查的目标路径，必须以"/"开头，允许输入具体的文件路径，默认为根目录，只支持输入数字、字母（大小写）、"."、“%”、"?"、“#”、“&”、“=”， 不得超过100字符。',
            healthCheckHttpCode:
                "检查来自后端实例的成功响应时，要使用的HTTP状态码。您可以输入2xx（等价于200-299）、3xx（等价于300-399）、4xx（等价于400-499），多个数值用“，”隔开。限制：目前仅支持输入2xx、3xx、4xx的正常态码。 "
        },
        serverGroup: {
            slbVpcName: "负载均衡所属VPC",
            instanceVpcName: "实例网口所属VPC",
            nameDuplicate: "该名称已存在",
            numberLimit: "仅支持添加100台服务器",
            serverGroupName: "虚拟服务组名称",
            sourceCount: "资源数量",
            deleteVirtualServerGroup: "删除虚拟服务器组",
            addVirtualServerGroup: "添加虚拟服务器组",
            editVirtualServerGroup: "编辑虚拟服务器组",
            virtualServerGroup: "虚拟服务器组",
            virtualServerGroupDetail: "虚拟服务器组详情",
            weightRange: "1-100整数",
            portRange: "1-65535整数",
            portRangePlaceHolder: "1-65535",
            weightRangePlaceHolder: "1-100",
            portNumberTip: "端口号必须唯一",
            defaultServerGroup: "默认服务器组",
            sourceType: "资源类型",
            instanceName: "实例名称",
            instanceId: "实例ID",
            region: "可用区",
            ipAddress: "目标内网IP地址",
            port: "端口",
            weights: "权重",
            status: "状态",
            operate: "操作",
            editWeight: "编辑权重",
            remove: "移除",
            add: "添加",
            cps: "云物理服务器",
            cancel: "取消",
            sure: "确定",
            editTip: "权重越高的服务器被转发到请求的概率越大",
            cpsName: "云物理服务器名称",
            addServer: "添加后端服务器",
            optionalServer: "可选实例",
            chosenServer: "已选实例",
            addServerTip:
                "最多支持添加100个服务器，相同云物理服务器的一个端口计为一个服务器",
            delete: "删除",
            removeTip: "确认要移除实例{0}吗"
        }
    },

    // 路由表
    rib: {
        rib: "路由表",
        helpDoc: "路由表帮助文档",
        configInfo: "配置信息",
        type: "类型",
        privateNetwork: "私有网络",
        id: "ID",
        name: "名称",
        createTime: "创建时间",
        region: "地域",
        sourceInfo: "资源信息",
        baseInfo: "基本信息",
        copySuccess: "复制成功",
        routeStrategy: "路由策略",
        defaultRib: "默认路由表",
        defaultRoute: "默认路由",
        tableTitle: {
            name: "名称",
            privateNetwork: "私有网络",
            type: "类型",
            createTime: "创建时间",
            destination: "目的端",
            nextHopType: "下一跳类型",
            nextHop: "下一跳"
        }
    },
    // ssh
    ssh: {
        text: {
            ssh: "SSH密钥",
            name: "密钥对名称",
            createTime: "创建时间",
            createType: "创建方式",
            create: "创建密钥",
            newParis: "创建新密钥对",
            existingPublicKeys: "使用已有公钥",
            enterPublicKey: "输入公钥",
            publicKeyFingerPrint: "公钥指纹"
        },
        help: {
            doc: "SSH密钥帮助文档",
            nameRule:
                "不允许为空且只允许为数字、大小写字母、英文下划线“_”及中划线“-”，不超过32字符",
            createTip:
                "创建完成后，请确认私钥已成功下载到本地。为保证云物理服务器安全，私钥只能下载一次，请妥善保管。",
            publicKeyPlaceholder: "公钥格式：ssh-rsa AAAAB3NzaC1yc2...",
            nameSame: "名称不能重复",
            publicKeyNotValid: "格式不正确，请重新输入",
            publicKeyNull: "公钥不能为空",
            deleteNotAllowed: "实例状态为创建中或者重装中不允许删除密钥",
            deleteKey: "删除密钥",
            deleteKeyTip:
                "密钥删除后，您仍可以使用本地保存的私钥登录绑定该密钥的云物理服务器。但是通过原始密钥无法访问SOS带外控制台，如需访问，请进行重置SOS操作。",
            confirmToDelete: "确认要删除{0}吗？",
            quotaFullUsed: "所选择资源限额已满，切换地域或者",
            increaseQuota: "提升配额",
            successAlert:
                "私钥会自动下载至您本地，请您务必需要保存好对应的私钥，并确保私钥不在Internet上传播，京东云不会保存您的私钥。"
        },
        operations: {
            delete: {
                name: "删除",
                tip: "实例状态为创建中或者重装中不允许删除密钥"
            }
        }
    },
    // ipv6
    ipv6: {
        text: {
            ipv6: "IPv6互联网网关",
            idOrGatewayName: "ID/网关名称",
            privateNetwork: "私有网络",
            createTime: "创建时间",
            manageIpv6Address: "管理IPv6地址",
            gatewayId: "网关ID",
            gatewayName: "网关名称",
            region: "地域",
            ipv6Eip: "IPv6 公网带宽",
            ipv6Address: "IPv6地址",
            ipv6AddressId: "IPv6地址 ID",
            ipv6Id: "IPv6 ID",
            openPublicnetwork: "开通公网",
            bandwidthLimit: "带宽上限",
            az: "可用区",
            openIpv6PublicNetwork: "开通IPv6公网",
            deleteIpv6PublicNetwork: "删除公网访问",
            choosedCount: "已选择",
            enableipv6CountTip: "单次操作最多可添加10个IPv6地址",
            bandwidthCalMode:
                "购买固定带宽类型IPv6公网带宽适用于网络情况较稳定的业务场景",
            buyNum: "购买数量",
            rip: "内网IP",
            aliasip: "别名IP"
        },
        speechCraft: {
            deleteIpv6CheckWarning: "您确定要删除IPv6地址{0}公网带宽吗?",
            afterDeleteIpv6Tip:
                "删除后IPv6地址的公网带宽值将变为 0Mbps ，仅具备私网通信权限。",
            openPublicnetworkTip1: "当前账号未打标签不能创建按配置计费资源，请",
            openPublicnetworkTip2: "提交工单",
            openPublicnetworkTip3: "申请打标后再进行开通公网操作"
        },
        placeholder: {
            search: {
                gatewayId: "请输入网关ID进行搜索",
                gatewayName: "请输入网关名称进行搜索",
                idSearch: "请输入实例ID搜索",
                nameSearch: "请输入实例名称搜索",
                ipv6Address: "请输入IPv6地址进行搜索",
                ipv6Id: "请输入IPv6 ID进行搜索",
                ipAddress: "请输入IPv6地址进行搜索",
                enableIpv6Address: "请选择需要开通公网的IPv6地址"
            }
        },
        operations: {
            manage: {
                name: "管理IPv6地址",
                tip: "实例状态为创建中或者重装中不允许删除密钥"
            }
        },
        help: {
            doc: "IPv6互联网网关帮助文档"
        }
    },
    // 自定义脚本
    customScript: {
        hasBase64: "当前输入内容已进行base64编码，请勾选'输入已采用base64编码'",
        noBase64:
            "当前输入的内容未进行base64编码，请取消勾选'输入已采用base64编码'",
        firstLine:
            "格式不正确，编码前须分别以#!/bin/bash和#!/usr/bin/env python作为内容首行",
        windowsFirstLine:
            "格式不正确，编码前须分别以“rem cmd”开头且作为内容首行和<powershell></powershell>作为内容首、尾行。",
        originMax: "当前输入内容编码前数据已大于16KB，请重新输入",
        encodeMax: "当前输入内容编码前数据已大于16KB，请重新输入"
    },
    game:{
        title: "游戏服务器",
        helpDoc: '游戏服务器帮助文档',
        list: {
            tutorial: "游戏教程",
            create: "创建游戏",
            windows: "Windows连接",
            windowsConnect: "Windows电脑连接游戏服务器",
            windowsConnectContent: {
                "method1": "方法1",
                "method2": "方法2",
                "method2Field": "如果方法1遇到问题，可以手动连接，具体如下：",
            },
            macConnect: "Mac电脑连接游戏服务器",
            macConnectContent: {
                "tips": "前提：Mac电脑安装好Windows远程桌面软件(比如 Microsoft Remote Desktop)"
            },
            playBtnText: "视频演示专区",
            mac: "MAC连接",
            other: "其他兼容性",
            otherConnect: "其他兼容性连接",
            connnectSetting: "（仅为连接设置）",
            gameGuide: "畅玩游戏攻略>>",
            steamGuide: "畅玩攻略设置（Steam）",
            deskGuide: "畅玩攻略设置（ToDesk)",
            practices: "最佳实践",
            recommendation: "推荐游戏",
            rapidDeployment:"快速部署",
            wukong: "黑神话悟空",
            questions: "常见问题",
            question: {
                'modifyBw': "购买游戏服务器后，如何修改带宽",
                "modifyCon": "如何升降配游戏服务器的配置 ",
                "connectServer": "如何一键连接游戏服务器",
                "renewal": "如何续费游戏服务器",
            },
            closeRedTip: "注意：实例关机后，仍然会产生计费。",
            closeTip: "确认关闭游戏服务器：{0}?",
            openTip: "确认开启游戏服务器：{0}?",
            restartTip: "确认重启游戏服务器：{0}?",
            deleteTip: '<span class="label">确认删除游戏服务器：</span>{0}?',
            sureCharge: "我已清楚费用问题，我同意自行删除关联的所有资源(含弹性公网IP)",
            linkType: "连接方式",
            oneClickConnection: "一键连接",
            oneClickDoc: "一键下载文件",
            oneClickConnectionTip: '请先"一键下载文件"',
            steamGuideTitle: "Steam畅玩模式（免费且只需要20Mbps带宽）",
            steamGuideTips: {
                setSteam: "1、设置Steam",
                streamGames: "2、串流玩游戏",
                exceptionHandling: "3、异常处理"
            },
            deskGuideTitle: "ToDesk畅玩模式（需要购买ToDesk游戏版并开启40Mbps带宽）",
            deskGuideTips: {
                setSteam: "1、设置ToDesk",
                streamGames: "2、ToDesk玩游戏",
                exceptionHandling: "3、ToDesk玩游戏高级设置"
            },
            specificationType: {
                gpu: "{0}，{1}GB显存",
                cpu: "{0} {1}核",
                memory: "{0} {1}GB",
                sysDisk: "{0}GB {1}",
                bw:"{0}Mbps"
            },
            gameServerGuide: "一键连接游戏服务器引导",
            modifyBandwidth: {
                tip: '若要调整公网带宽大小，可前往弹性公网IP列表页-点击修改带宽操作即可。'
            },
            resetPasswordTip: "重置实例密码后，只有在控制台对实例进行开机才能生效。"
        },
        create: {
            buyInstance: "创建游戏服务器",
            game: "游戏",
            configuration: "配置",
            tips: {
                wukong: "注：您需自行到Steam购买游戏，通过快速部署即可畅玩。",
                payByHour: "按实际使用时长以小时为单位结算。",
                payByDay: "预付费模式，按月购买及续费，相较按配置具有较大优惠。"
            },
            payByHour: "按小时",
            payByDay: "按月",
            gpu: "GPU",
            cpu: "CPU",
            memory: "内存",
            sysDisk: "系统盘",
            eip: "公网带宽",
            feePerHour: '¥{0}/每小时',
            feePerDay: '¥{0}',
            feePer: '¥{0} ',
            oneHour: ' 每小时',
            oneDay: ' 每月',
            gpu: 'GPU',
            cpu: 'CPU',
            memory: '内存',
            sysDisk: '系统盘',
            soldOut: '已售罄',
            videoMemory: '显存',
            feeDetail: '费用明细',
            configFee: '配置费用',
            configDetail: '配置明细',
            feeItem: '计费项',
            originPrice: "原价",
            discount: '折扣',
            cost: "费用",
            noStock: '库存不足',
            buyNow: '立即购买',
            generatePwd: '随机生成密码',
            randomPasswordTip1: '1、密码用于远程登录连接服务器的凭证，请妥善保存。',
            randomPasswordTip2: '2、打开小眼睛，支持复制密码。',
            randomPasswordTip3: '3、若要修改密码，请通过操作-重置密码即可。',
        },
        tips: {
            deleteVpc: "如需删除请提交工单",
            createTip: "点击创建游戏即可快速部署",
        },
        action: {
            resettingPassword: '重置密码中',
            backCPSGameListText: '更多地域',
        }
    }
};



// WEBPACK FOOTER //
// ./src/common/i18n/zh-CN.js